import * as e42 from 'react';
import e42__default, { forwardRef, Children, isValidElement, createElement, cloneElement, useEffect, useRef, useState, useCallback, createContext, useMemo, Fragment, useSyncExternalStore, useLayoutEffect, useContext } from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import f, { mutate } from 'swr';
import h from 'swr/mutation';
import { Eip1193Bridge } from 'eip1193bridge';
import { createWalletClient, custom, parseUnits, createPublicClient } from 'viem';
import '@radix-ui/react-popover';
import '@reach/rect';
import * as r5 from '@radix-ui/react-tooltip';
import * as t23 from '@radix-ui/react-select';
import * as o6 from '@radix-ui/react-scroll-area';
import * as r9 from '@radix-ui/react-dialog';
import d4 from 'react-dom';
import * as o7 from '@radix-ui/react-tabs';
import { atom, listenKeys } from 'nanostores';
import { arbitrum, avalanche, base, bsc, mainnet, scroll, optimism, linea, cronos, manta, polygon, fantom } from 'viem/chains';
import E from 'lodash';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var c = /* @__PURE__ */ __name((...r12) => twMerge(clsx(...r12)), "c");

// ../shared/dist/constants/api/index.js
var t2 = "https://api.gasbot.xyz/v3";
var d = /* @__PURE__ */ __name((...e44) => {
  const [s7, t31] = e44;
  return f(s7, async (c11) => {
    const o12 = await fetch(t2 + c11), n7 = await o12.json();
    if (o12.ok)
      return n7;
    throw new Error(n7);
  }, t31);
}, "d");
var x = /* @__PURE__ */ __name((...e44) => {
  const [s7, t31] = e44;
  async function a5(c11, { arg: o12 }) {
    return new Promise(async (n7, i5) => {
      try {
        const r12 = await fetch(t2 + c11, {
          method: (t31 == null ? void 0 : t31.method) ?? "POST",
          body: JSON.stringify(o12),
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "xxx"
          }
        }), u6 = await r12.json();
        return r12.ok ? n7(u6) : i5(u6);
      } catch (r12) {
        i5(r12);
      }
    });
  }
  __name(a5, "a");
  return h(s7, a5, t31);
}, "x");

// ../shared/dist/lib/utils/index.js
var a = /* @__PURE__ */ __name((t31) => {
  if (!t31)
    return "No Account";
  const e44 = t31.match(
    /^(0x[a-zA-Z0-9]{4})[a-zA-Z0-9]+([a-zA-Z0-9]{8})$/
  );
  return e44 ? `${e44[1]}\u2026${e44[2]}` : t31;
}, "a");
var c2 = /* @__PURE__ */ __name((t31, e44) => t31.toFixed(e44 ?? 2).replace(/^0+(\d)|(\d)0+$/gm, "$1$2"), "c");
var s = /* @__PURE__ */ __name(async (t31) => {
  await navigator.clipboard.writeText(t31);
}, "s");
var d2 = /* @__PURE__ */ __name((t31, e44, r12) => {
  const n7 = t31 * Math.pow(10, -e44);
  return r12 / n7;
}, "d");
var u = /* @__PURE__ */ __name((t31, e44) => {
  let r12 = true;
  for (const n7 of e44)
    if (t31[n7] === void 0) {
      r12 = false;
      break;
    }
  return r12;
}, "u");
var f2 = createWalletClient({
  transport: custom({ request: () => null })
});
var b = /* @__PURE__ */ __name((t31) => {
  function e44() {
    if (!t31)
      return f2;
    const s7 = u(t31, [
      "transport",
      "uid"
    ]), o12 = t31, a5 = t31;
    return s7 ? o12 : new Eip1193Bridge(a5);
  }
  __name(e44, "e");
  function i5() {
    return createPublicClient({
      transport: custom(e44())
    });
  }
  __name(i5, "i");
  function l9() {
    return createWalletClient({
      transport: custom(e44())
    });
  }
  __name(l9, "l");
  return {
    publicClient: i5(),
    walletClient: l9()
  };
}, "b");
var t3 = /* @__PURE__ */ __name((r12) => /* @__PURE__ */ e42.createElement("svg", { id: "alert-octagon", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r12 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("path", { d: "M12 7.75V13", stroke: "#292D32", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("path", { d: "M21.08 8.58003V15.42C21.08 16.54 20.48 17.58 19.51 18.15L13.57 21.58C12.6 22.14 11.4 22.14 10.42 21.58L4.47998 18.15C3.50998 17.59 2.90997 16.55 2.90997 15.42V8.58003C2.90997 7.46003 3.50998 6.41999 4.47998 5.84999L10.42 2.42C11.39 1.86 12.59 1.86 13.57 2.42L19.51 5.84999C20.48 6.41999 21.08 7.45003 21.08 8.58003Z", stroke: "currentcolor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("path", { d: "M12 16.2V16.2999", stroke: "currentcolor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }))), "t");
var t4 = /* @__PURE__ */ __name((l9) => /* @__PURE__ */ e42.createElement("svg", { id: "arrow-left", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...l9 }, /* @__PURE__ */ e42.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.3508 12.7499L11.2096 17.4615L10.1654 18.5383L3.4226 11.9999L10.1654 5.4615L11.2096 6.5383L6.3508 11.2499L21 11.2499V12.7499L6.3508 12.7499Z", fill: "currentcolor" })), "t");
var l2 = /* @__PURE__ */ __name((t31) => /* @__PURE__ */ e42.createElement("svg", { id: "arrow-right", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t31 }, /* @__PURE__ */ e42.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.6492 11.2501L12.7904 6.53852L13.8346 5.46167L20.5774 12.0001L13.8346 18.5385L12.7904 17.4617L17.6492 12.7501H3V11.2501H17.6492Z", fill: "currentcolor" })), "l");
var C = /* @__PURE__ */ __name((e44) => /* @__PURE__ */ e42.createElement("svg", { id: "bolt", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e44 }, /* @__PURE__ */ e42.createElement("path", { d: "M12.8758 6H9.74978L10.3543 2.37375C10.3723 2.26624 10.3666 2.15609 10.3377 2.05099C10.3088 1.94589 10.2573 1.84836 10.1868 1.76519C10.1163 1.68202 10.0286 1.61521 9.92967 1.56941C9.83075 1.52361 9.72304 1.49992 9.61403 1.5H5.75003C5.57261 1.50005 5.40095 1.563 5.26556 1.67766C5.13017 1.79232 5.0398 1.95126 5.01053 2.12625L3.76028 9.62625C3.7423 9.7337 3.74795 9.84378 3.77683 9.94882C3.80572 10.0539 3.85713 10.1514 3.92752 10.2345C3.9979 10.3177 4.08555 10.3845 4.18438 10.4304C4.28321 10.4762 4.39084 10.5 4.49978 10.5H7.49978V16.5L13.5073 7.15575C13.5802 7.04241 13.6212 6.91151 13.626 6.77683C13.6309 6.64214 13.5993 6.50865 13.5347 6.39038C13.4701 6.27212 13.3748 6.17345 13.2588 6.10475C13.1429 6.03605 13.0105 5.99987 12.8758 6Z", fill: "currentcolor" })), "C");
var t6 = /* @__PURE__ */ __name((r12) => /* @__PURE__ */ e42.createElement("svg", { id: "cancel", viewBox: "0 0 512 512", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "currentcolor", ...r12 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("title", null, "cancel"), /* @__PURE__ */ e42.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e42.createElement("g", { id: "work-case", fill: "currentcolor", transform: "translate(91.520000, 91.520000)" }, /* @__PURE__ */ e42.createElement("polygon", { id: "Close", points: "328.96 30.2933333 298.666667 1.42108547e-14 164.48 134.4 30.2933333 1.42108547e-14 1.42108547e-14 30.2933333 134.4 164.48 1.42108547e-14 298.666667 30.2933333 328.96 164.48 194.56 298.666667 328.96 328.96 298.666667 194.56 164.48" }))))), "t");
var t7 = /* @__PURE__ */ __name((r12) => /* @__PURE__ */ e42.createElement("svg", { id: "check-circle", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r12 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("rect", { width: 24, height: 24, fill: "none" }), /* @__PURE__ */ e42.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L12.0243 14.3899C11.4586 14.9556 10.5414 14.9556 9.97568 14.3899L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929C8.68342 10.9024 9.31658 10.9024 9.70711 11.2929L11 12.5858L14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289Z", fill: "currentcolor" }))), "t");
var t8 = /* @__PURE__ */ __name((r12) => /* @__PURE__ */ e42.createElement("svg", { id: "check", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 512 512", xmlSpace: "preserve", fill: "currentcolor", ...r12 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("g", null, /* @__PURE__ */ e42.createElement("path", { fill: "currentcolor", d: "M469.402,35.492C334.09,110.664,197.114,324.5,197.114,324.5L73.509,184.176L0,254.336l178.732,222.172 l65.15-2.504C327.414,223.414,512,55.539,512,55.539L469.402,35.492z" })))), "t");
var t9 = /* @__PURE__ */ __name((l9) => /* @__PURE__ */ e42.createElement("svg", { id: "chevron-down", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...l9 }, /* @__PURE__ */ e42.createElement("g", { clipPath: "url(#clip0_177_3054)" }, /* @__PURE__ */ e42.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.8441 2.6399C11.6476 2.4449 11.3297 2.4449 11.1342 2.6399L5.99215 8.28486L0.851163 2.6399C0.655163 2.4449 0.337141 2.4449 0.141141 2.6399C-0.0548594 2.8399 -0.0548594 3.15987 0.141141 3.35487L5.61264 9.35987C5.71714 9.46487 5.85565 9.50989 5.99215 9.49989C6.12915 9.50989 6.26765 9.46487 6.37265 9.35987L11.8441 3.35487C12.0396 3.15987 12.0396 2.8399 11.8441 2.6399Z", fill: "currentcolor" })), /* @__PURE__ */ e42.createElement("defs", null, /* @__PURE__ */ e42.createElement("clipPath", { id: "clip0_177_3054" }, /* @__PURE__ */ e42.createElement("path", { d: "M0 0H12V6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6V0Z", fill: "white" })))), "t");
var t10 = /* @__PURE__ */ __name((e44) => /* @__PURE__ */ e42.createElement("svg", { id: "cloud-download", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e44 }, /* @__PURE__ */ e42.createElement("path", { d: "M15 15V23.75M15 23.75L12.1875 20.8334M15 23.75L17.8125 20.8334M8.25 22.2916C5.76472 22.2916 3.75 20.2396 3.75 17.7084C3.75 15.6225 5.11798 13.8621 6.98997 13.3071C7.06952 13.2835 7.125 13.2094 7.125 13.125C7.125 9.32804 10.1471 6.25 13.875 6.25C17.6029 6.25 20.625 9.32804 20.625 13.125C20.625 13.1978 20.692 13.2518 20.7617 13.2359C21.0797 13.1633 21.4105 13.125 21.75 13.125C24.2352 13.125 26.25 15.177 26.25 17.7084C26.25 20.2396 24.2352 22.2916 21.75 22.2916", stroke: "currentcolor", strokeWidth: 1.29167, strokeLinecap: "round", strokeLinejoin: "round" })), "t");
var t11 = /* @__PURE__ */ __name((r12) => /* @__PURE__ */ e42.createElement("svg", { id: "copy", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r12 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5 16.5L19.5 4.5L18.75 3.75H9L8.25 4.5L8.25 7.5L5.25 7.5L4.5 8.25V20.25L5.25 21H15L15.75 20.25V17.25H18.75L19.5 16.5ZM15.75 15.75L15.75 8.25L15 7.5L9.75 7.5V5.25L18 5.25V15.75H15.75ZM6 9L14.25 9L14.25 19.5L6 19.5L6 9Z", fill: "currentcolor" }))), "t");
var t12 = /* @__PURE__ */ __name((e44) => /* @__PURE__ */ e42.createElement("svg", { id: "discord", viewBox: "0 0 24 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e44 }, /* @__PURE__ */ e42.createElement("path", { d: "M20.3137 1.55304C18.7606 0.833337 17.1066 0.303032 15.3641 0C15.1495 0.37879 14.897 0.896468 14.7328 1.31314C12.8894 1.03536 11.0586 1.03536 9.25302 1.31314C9.07625 0.896468 8.82372 0.37879 8.60908 0C6.86664 0.303032 5.2126 0.833337 3.65956 1.55304C0.528233 6.27528 -0.31773 10.8839 0.0989384 15.4168C2.18228 16.9698 4.18986 17.9042 6.1722 18.5228C6.66462 17.8537 7.09392 17.1339 7.47271 16.389C6.75301 16.1238 6.07119 15.7829 5.42724 15.3915C5.60401 15.2653 5.76815 15.1264 5.9323 15.0001C9.88432 16.8435 14.1646 16.8435 18.0662 15.0001C18.2303 15.139 18.3945 15.2653 18.5712 15.3915C17.9273 15.7829 17.2328 16.1112 16.5258 16.389C16.9046 17.1339 17.3338 17.8537 17.8263 18.5228C19.8086 17.9042 21.8288 16.9698 23.8995 15.4168C24.392 10.1516 23.0536 5.59346 20.3389 1.55304H20.3137ZM8.00301 12.639C6.81614 12.639 5.84391 11.5405 5.84391 10.1895C5.84391 8.83846 6.79089 7.73997 8.00301 7.73997C9.21514 7.73997 10.1747 8.83846 10.1621 10.1895C10.1621 11.5279 9.21514 12.639 8.00301 12.639ZM15.9702 12.639C14.7833 12.639 13.8111 11.5405 13.8111 10.1895C13.8111 8.83846 14.7581 7.73997 15.9702 7.73997C17.1823 7.73997 18.1419 8.83846 18.1293 10.1895C18.1293 11.5279 17.1823 12.639 15.9702 12.639Z", fill: "currentcolor" })), "t");
var o3 = /* @__PURE__ */ __name((r12) => /* @__PURE__ */ e42.createElement("svg", { fill: "currentcolor", viewBox: "0 0 24 24", id: "double-arrow-down", "data-name": "Line Color", xmlns: "http://www.w3.org/2000/svg", className: "icon line-color", ...r12 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("polyline", { id: "secondary", points: "4 17 7 20 10 17", style: {
  fill: "none",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
} }), /* @__PURE__ */ e42.createElement("line", { id: "secondary-2", "data-name": "secondary", x1: 7, y1: 4, x2: 7, y2: 20, style: {
  fill: "none",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
} }), /* @__PURE__ */ e42.createElement("line", { id: "primary", x1: 17, y1: 4, x2: 17, y2: 20, style: {
  fill: "none",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
} }), /* @__PURE__ */ e42.createElement("polyline", { id: "primary-2", "data-name": "primary", points: "14 17 17 20 20 17", style: {
  fill: "none",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
} }))), "o");
var t13 = /* @__PURE__ */ __name((l9) => /* @__PURE__ */ e42.createElement("svg", { id: "edit-off", fill: "currentcolor", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 32 32", xmlSpace: "preserve", ...l9 }, /* @__PURE__ */ e42.createElement("g", { strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", null, /* @__PURE__ */ e42.createElement("path", { d: "M30,28.6L3.4,2L2,3.4l10.1,10.1L4,21.6V28h6.4l8.1-8.1L28.6,30L30,28.6z M9.6,26H6v-3.6l7.5-7.5l3.6,3.6L9.6,26z" }), /* @__PURE__ */ e42.createElement("path", { d: "M29.4,6.2L29.4,6.2l-3.6-3.6c-0.8-0.8-2-0.8-2.8,0l0,0l0,0l-8,8l1.4,1.4L20,8.4l3.6,3.6L20,15.6l1.4,1.4l8-8 C30.2,8.2,30.2,7,29.4,6.2L29.4,6.2z M25,10.6L21.4,7l3-3L28,7.6L25,10.6z" }))), "t");
var t14 = /* @__PURE__ */ __name((r12) => /* @__PURE__ */ e42.createElement("svg", { id: "error-circle", viewBox: "0 0 24 24", role: "img", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": "errorIconTitle", stroke: "currentcolor", strokeWidth: 1, strokeLinecap: "square", strokeLinejoin: "miter", fill: "none", color: "currentcolor", ...r12 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("title", { id: "errorIconTitle" }, "Error"), /* @__PURE__ */ e42.createElement("path", { d: "M12 8L12 13" }), /* @__PURE__ */ e42.createElement("line", { x1: 12, y1: 16, x2: 12, y2: 16 }), /* @__PURE__ */ e42.createElement("circle", { cx: 12, cy: 12, r: 10 }))), "t");
var t15 = /* @__PURE__ */ __name((e44) => /* @__PURE__ */ e42.createElement("svg", { id: "handshake", viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e44 }, /* @__PURE__ */ e42.createElement("g", { clipPath: "url(#clip0_697_57)" }, /* @__PURE__ */ e42.createElement("path", { d: "M17.4165 11.8748H16.9415L10.4498 5.38311C10.3794 5.30633 10.2937 5.24502 10.1983 5.20308C10.103 5.16114 9.99988 5.13949 9.89567 5.13949C9.79146 5.13949 9.68839 5.16114 9.59299 5.20308C9.4976 5.24502 9.41196 5.30633 9.3415 5.38311L7.00609 7.71853C6.93209 7.79106 6.83261 7.83168 6.729 7.83168C6.62539 7.83168 6.52591 7.79106 6.45192 7.71853L5.85817 7.12478L6.4915 6.49145L9.89567 3.08728L13.2998 6.49145C13.446 6.64061 13.6452 6.72597 13.854 6.72895H17.4165C17.6265 6.72895 17.8278 6.64554 17.9763 6.49707C18.1248 6.3486 18.2082 6.14724 18.2082 5.93728C18.2082 5.72732 18.1248 5.52595 17.9763 5.37749C17.8278 5.22902 17.6265 5.14561 17.4165 5.14561H14.1707L10.4498 1.42478C10.3794 1.34799 10.2937 1.28669 10.1983 1.24475C10.103 1.20281 9.99988 1.18115 9.89567 1.18115C9.79146 1.18115 9.68839 1.20281 9.59299 1.24475C9.4976 1.28669 9.41196 1.34799 9.3415 1.42478L5.62067 5.14561H1.58317C1.37321 5.14561 1.17184 5.22902 1.02338 5.37749C0.874911 5.52595 0.791504 5.72732 0.791504 5.93728C0.791504 6.14724 0.874911 6.3486 1.02338 6.49707C1.17184 6.64554 1.37321 6.72895 1.58317 6.72895H4.19567C4.11205 6.93746 4.09377 7.16647 4.14325 7.38561C4.19274 7.60475 4.30765 7.80368 4.47275 7.95603L5.34359 8.82686C5.71355 9.1895 6.21095 9.39262 6.729 9.39262C7.24706 9.39262 7.74446 9.1895 8.11442 8.82686L9.89567 7.04561L16.0707 13.2206C16.2168 13.3698 16.416 13.4551 16.6248 13.4581H17.4165C17.6265 13.4581 17.8278 13.3747 17.9763 13.2262C18.1248 13.0778 18.2082 12.8764 18.2082 12.6664C18.2082 12.4565 18.1248 12.2551 17.9763 12.1067C17.8278 11.9582 17.6265 11.8748 17.4165 11.8748Z", fill: "currentcolor" }), /* @__PURE__ */ e42.createElement("path", { d: "M12.429 10.9252C12.2766 10.8108 12.088 10.7553 11.8979 10.7688C11.7078 10.7823 11.529 10.864 11.3942 10.9987C11.2595 11.1335 11.1779 11.3123 11.1643 11.5024C11.1508 11.6925 11.2063 11.8811 11.3207 12.0335L14.0915 14.8043C14.162 14.8811 14.2476 14.9424 14.343 14.9844C14.4384 15.0263 14.5415 15.048 14.6457 15.048C14.7499 15.048 14.853 15.0263 14.9484 14.9844C15.0438 14.9424 15.1294 14.8811 15.1999 14.8043C15.2766 14.7339 15.3379 14.6483 15.3799 14.5529C15.4218 14.4575 15.4435 14.3544 15.4435 14.2502C15.4435 14.146 15.4218 14.0429 15.3799 13.9475C15.3379 13.8521 15.2766 13.7665 15.1999 13.696L12.429 10.9252Z", fill: "currentcolor" }), /* @__PURE__ */ e42.createElement("path", { d: "M10.054 12.1127C9.90157 11.9983 9.71299 11.9428 9.5229 11.9563C9.33281 11.9698 9.15398 12.0515 9.01923 12.1862C8.88448 12.321 8.80286 12.4998 8.78935 12.6899C8.77584 12.88 8.83135 13.0686 8.94569 13.221L11.7165 15.9918C11.787 16.0686 11.8726 16.1299 11.968 16.1719C12.0634 16.2138 12.1665 16.2355 12.2707 16.2355C12.3749 16.2355 12.478 16.2138 12.5734 16.1719C12.6688 16.1299 12.7544 16.0686 12.8249 15.9918C12.9016 15.9214 12.9629 15.8358 13.0049 15.7404C13.0468 15.645 13.0685 15.5419 13.0685 15.4377C13.0685 15.3335 13.0468 15.2304 13.0049 15.135C12.9629 15.0396 12.9016 14.954 12.8249 14.8835L10.054 12.1127Z", fill: "currentcolor" }), /* @__PURE__ */ e42.createElement("path", { d: "M7.28364 12.9042C7.13118 12.7898 6.9426 12.7343 6.75251 12.7478C6.56243 12.7614 6.38359 12.843 6.24884 12.9777C6.11409 13.1125 6.03247 13.2913 6.01896 13.4814C6.00545 13.6715 6.06096 13.8601 6.1753 14.0125L8.94614 16.7834C9.01659 16.8601 9.10223 16.9214 9.19762 16.9634C9.29302 17.0053 9.39609 17.027 9.5003 17.027C9.60451 17.027 9.70758 17.0053 9.80298 16.9634C9.89838 16.9214 9.98402 16.8601 10.0545 16.7834C10.1313 16.7129 10.1926 16.6273 10.2345 16.5319C10.2764 16.4365 10.2981 16.3334 10.2981 16.2292C10.2981 16.125 10.2764 16.0219 10.2345 15.9265C10.1926 15.8311 10.1313 15.7455 10.0545 15.675L7.28364 12.9042Z", fill: "currentcolor" }), /* @__PURE__ */ e42.createElement("path", { d: "M2.929 12.1125C2.78284 11.9633 2.58365 11.878 2.37484 11.875H1.58317C1.37321 11.875 1.17184 11.9584 1.02338 12.1069C0.874911 12.2553 0.791504 12.4567 0.791504 12.6667C0.791504 12.8766 0.874911 13.078 1.02338 13.2265C1.17184 13.3749 1.37321 13.4583 1.58317 13.4583H2.05817L6.17484 17.575C6.24529 17.6518 6.33093 17.7131 6.42633 17.755C6.52172 17.797 6.62479 17.8186 6.729 17.8186C6.83321 17.8186 6.93628 17.797 7.03168 17.755C7.12708 17.7131 7.21272 17.6518 7.28317 17.575C7.35995 17.5045 7.42126 17.4189 7.4632 17.3235C7.50514 17.2281 7.5268 17.125 7.5268 17.0208C7.5268 16.9166 7.50514 16.8136 7.4632 16.7182C7.42126 16.6228 7.35995 16.5371 7.28317 16.4667L2.929 12.1125Z", fill: "currentcolor" }))), "t");
var C4 = /* @__PURE__ */ __name((r12) => /* @__PURE__ */ e42.createElement("svg", { id: "info-circle", viewBox: "-0.5 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r12 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("path", { d: "M12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 7.14137 17.1086 3 12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5Z", stroke: "currentcolor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("path", { d: "M12.9309 8.15005C12.9256 8.39231 12.825 8.62272 12.6509 8.79123C12.4767 8.95974 12.2431 9.05271 12.0008 9.05002C11.8242 9.04413 11.6533 8.98641 11.5093 8.884C11.3652 8.7816 11.2546 8.63903 11.1911 8.47415C11.1275 8.30927 11.1139 8.12932 11.152 7.95675C11.19 7.78419 11.278 7.6267 11.405 7.50381C11.532 7.38093 11.6923 7.29814 11.866 7.26578C12.0397 7.23341 12.2192 7.25289 12.3819 7.32181C12.5446 7.39072 12.6834 7.506 12.781 7.65329C12.8787 7.80057 12.9308 7.97335 12.9309 8.15005ZM11.2909 16.5301V11.1501C11.2882 11.0556 11.3046 10.9615 11.3392 10.8736C11.3738 10.7857 11.4258 10.7057 11.4922 10.6385C11.5585 10.5712 11.6378 10.518 11.7252 10.4822C11.8126 10.4464 11.9064 10.4286 12.0008 10.43C12.094 10.4299 12.1863 10.4487 12.272 10.4853C12.3577 10.5218 12.4352 10.5753 12.4997 10.6426C12.5642 10.7099 12.6143 10.7895 12.6472 10.8767C12.6801 10.9639 12.6949 11.0569 12.6908 11.1501V16.5301C12.6908 16.622 12.6727 16.713 12.6376 16.7979C12.6024 16.8828 12.5508 16.96 12.4858 17.025C12.4208 17.09 12.3437 17.1415 12.2588 17.1767C12.1738 17.2119 12.0828 17.23 11.9909 17.23C11.899 17.23 11.8079 17.2119 11.723 17.1767C11.6381 17.1415 11.5609 17.09 11.4959 17.025C11.4309 16.96 11.3793 16.8828 11.3442 16.7979C11.309 16.713 11.2909 16.622 11.2909 16.5301Z", fill: "currentcolor" }))), "C");
var t16 = /* @__PURE__ */ __name((r12) => /* @__PURE__ */ e42.createElement("svg", { id: "link-out", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r12 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("path", { d: "M13.5 10.5L21 3", stroke: "currentcolor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("path", { d: "M16 3L21 3L21 8", stroke: "currentcolor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("path", { d: "M21 14V19C21 20.1046 20.1046 21 19 21H12H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H10", stroke: "currentcolor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }))), "t");
var l3 = /* @__PURE__ */ __name((C10) => /* @__PURE__ */ e42.createElement("svg", { id: "link-round", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...C10 }, /* @__PURE__ */ e42.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.3719 8.26448C2.62603 11.0104 2.62603 15.4623 5.3719 18.2082C6.64493 19.4812 8.28653 20.1645 9.95273 20.2567C10.3835 20.2806 10.7521 19.9507 10.776 19.5199C10.7999 19.0891 10.47 18.7205 10.0391 18.6966C8.74199 18.6248 7.46752 18.094 6.47676 17.1033C4.34108 14.9676 4.34108 11.505 6.47676 9.36933L9.42304 6.42305C11.5587 4.28737 15.0214 4.28737 17.157 6.42305C19.2927 8.55873 19.2927 12.0213 17.157 14.1571L15.6839 15.6302C15.3787 15.9353 15.3787 16.43 15.6839 16.735C15.989 17.0401 16.4836 17.0401 16.7887 16.735L18.2619 15.2619C21.0077 12.516 21.0077 8.06407 18.2619 5.3182C15.516 2.57232 11.0641 2.57232 8.31818 5.3182L5.3719 8.26448Z", fill: "currentcolor" }), /* @__PURE__ */ e42.createElement("path", { opacity: 0.5, d: "M13.842 18.5771C11.7063 16.4414 11.7063 12.9788 13.842 10.8431L15.3151 9.36999C15.6202 9.06488 15.6202 8.57023 15.3151 8.26513C15.01 7.96003 14.5153 7.96003 14.2102 8.26513L12.7371 9.73827C9.99127 12.4841 9.99127 16.9361 12.7371 19.682C15.4831 22.4278 19.9349 22.4278 22.6809 19.682L25.6271 16.7357C28.373 13.9898 28.373 9.53786 25.6271 6.79199C24.3541 5.51897 22.7125 4.83571 21.0463 4.7434C20.6155 4.71954 20.2469 5.04944 20.2231 5.48025C20.1992 5.91106 20.5291 6.27965 20.9598 6.30352C22.257 6.37537 23.5315 6.90608 24.5222 7.89684C26.658 10.0325 26.658 13.4952 24.5222 15.6308L21.576 18.5771C19.4403 20.7128 15.9776 20.7128 13.842 18.5771Z", fill: "currentcolor" })), "l");
var t17 = /* @__PURE__ */ __name((r12) => /* @__PURE__ */ e42.createElement("svg", { id: "lock-alt", viewBox: "0 0 1024 1024", fill: "currentcolor", xmlns: "http://www.w3.org/2000/svg", ...r12 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M666 486v-76.4c0-84.8-69.2-153.6-154-153.6s-154 68.8-154 153.6V486h-51v282h410V486h-51zm-256-76.4c0-56.6 45.4-102.4 102-102.4S614 353 614 409.6V486H410v-76.4z" }))), "t");
var o4 = /* @__PURE__ */ __name((l9) => /* @__PURE__ */ e42.createElement("svg", { id: "lock", viewBox: "0 0 28 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...l9 }, /* @__PURE__ */ e42.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.1193 19.4118C21.1193 20.1248 20.5395 20.7059 19.8251 20.7059H8.17809C7.46502 20.7059 6.88396 20.1248 6.88396 19.4118V11.6471H21.1193V19.4118V19.4118ZM19.8251 10.3529V5.82353C19.8251 2.61282 17.2123 0 14.0016 0C10.7909 0 8.17807 2.61282 8.17807 5.82353V10.3529H5.58984V19.4118C5.58984 20.8392 6.75066 22 8.17807 22H19.8251C21.2525 22 22.4134 20.8392 22.4134 19.4118V10.3529H19.8251ZM14.6487 14.2353V18.1176H13.3546V14.2353H14.6487ZM14.0016 1.2941C16.4993 1.2941 18.531 3.32587 18.531 5.82351V10.3529H9.4722V5.82353C9.4722 3.32588 11.504 1.2941 14.0016 1.2941Z", fill: "currentcolor" })), "o");
var e17 = /* @__PURE__ */ __name((L3) => /* @__PURE__ */ e42.createElement("svg", { id: "logo", viewBox: "0 0 344 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...L3 }, /* @__PURE__ */ e42.createElement("path", { d: "M115.012 36.0886C109.081 36.0886 104.6 37.4065 101.569 40.0424C98.5379 42.6782 97.0223 46.5661 97.0223 51.706V57.6367H127.17V68.5096H97.0223V95H84.1725V51.706C84.1725 43.3372 86.8413 36.7805 92.1789 32.0359C97.5824 27.2255 104.996 24.8203 114.419 24.8203C118.373 24.8203 122.063 25.2486 125.49 26.1053C128.916 26.9619 131.914 28.2139 134.484 29.8614L130.432 40.3389C126.346 37.5053 121.206 36.0886 115.012 36.0886ZM159.329 95.6919C153.86 95.6919 149.576 94.2092 146.479 91.2439C143.448 88.2127 141.932 83.9623 141.932 78.4929V21.6572H154.288V77.6033C154.288 82.8751 156.759 85.5109 161.701 85.5109C163.349 85.5109 164.832 85.1814 166.149 84.5225L166.743 94.4069C164.436 95.2636 161.965 95.6919 159.329 95.6919ZM197.303 85.2144C203.035 85.2144 207.813 83.3034 211.635 79.4814L218.159 87.0924C215.852 89.926 212.887 92.0676 209.263 93.5173C205.638 94.9671 201.553 95.6919 197.006 95.6919C191.207 95.6919 186.1 94.5387 181.685 92.2323C177.27 89.926 173.843 86.73 171.405 82.6444C169.033 78.4929 167.847 73.8143 167.847 68.6085C167.847 63.4685 169 58.8558 171.306 54.7702C173.679 50.6187 176.908 47.3898 180.993 45.0834C185.145 42.7771 189.823 41.6239 195.029 41.6239C199.971 41.6239 204.452 42.7112 208.472 44.8857C212.558 46.9944 215.786 50.0586 218.159 54.0783C220.531 58.0321 221.717 62.6778 221.717 68.0154L181.29 75.923C182.542 78.9542 184.552 81.2606 187.319 82.8421C190.087 84.4236 193.415 85.2144 197.303 85.2144ZM195.029 51.5083C190.482 51.5083 186.792 52.991 183.958 55.9564C181.191 58.9217 179.807 62.9084 179.807 67.9166V68.0154L209.658 62.2824C208.801 59.0535 207.055 56.4506 204.419 54.4737C201.849 52.4968 198.719 51.5083 195.029 51.5083ZM263.77 95L250.228 76.7137L236.588 95H222.947L243.507 68.2131L223.837 42.2169H237.576L250.525 59.5148L263.474 42.2169H276.818L257.049 68.0154L277.707 95H263.77ZM334.985 42.2169V86.9936C334.985 105.576 325.859 114.868 307.605 114.868C302.795 114.868 298.182 114.209 293.767 112.891C289.418 111.639 285.827 109.794 282.993 107.356L288.528 98.0642C290.769 99.9752 293.504 101.491 296.733 102.611C299.961 103.731 303.355 104.291 306.914 104.291C312.317 104.291 316.271 102.973 318.775 100.338C321.345 97.7677 322.63 93.7809 322.63 88.3774V85.9063C320.653 88.0809 318.248 89.7612 315.414 90.9474C312.581 92.0676 309.516 92.6277 306.222 92.6277C299.171 92.6277 293.602 90.6838 289.517 86.7959C285.497 82.908 283.487 77.0762 283.487 69.3004V42.2169H295.843V67.7189C295.843 72.3975 296.897 75.923 299.006 78.2952C301.181 80.6016 304.245 81.7548 308.199 81.7548C312.614 81.7548 316.106 80.4039 318.676 77.7022C321.312 75.0004 322.63 71.0796 322.63 65.9397V42.2169H334.985Z", fill: "currentcolor" }), /* @__PURE__ */ e42.createElement("path", { d: "M23.3722 83.3567L37.7956 60.1423C38.3582 59.2469 39.5334 58.966 40.4287 59.5286L47.5989 63.9821C48.4943 64.5447 48.7752 65.7198 48.2126 66.6152L33.7892 89.8295C33.2266 90.7249 32.0515 91.0058 31.1561 90.4432L23.9859 85.9897C23.0881 85.4429 22.8096 84.252 23.3722 83.3567Z", fill: "currentfill" }), /* @__PURE__ */ e42.createElement("path", { d: "M34.1904 29.1769C33.8766 31.1454 34.1158 33.089 34.7731 34.8408L5.11769 82.594L2.64205 86.5755C1.7686 88.0026 1.88864 89.7818 2.8335 91.0467C3.12722 91.4326 3.47573 91.7789 3.91803 92.0432L7.69405 94.3891L23.6223 104.276C25.4892 105.429 27.9547 104.854 29.1057 103.002L31.3844 99.3449C32.5379 97.478 31.9621 95.0124 30.1109 93.8615L17.461 85.9991L44.8326 41.935C50.2684 42.0749 55.1066 38.1634 55.9854 32.6517C56.9419 26.6518 52.8409 20.9759 46.8253 20.0168C40.8254 19.0602 35.1495 23.1612 34.1904 29.1769ZM50.9776 31.8533C50.6939 33.6328 49.6529 35.0977 48.2381 35.9703C47.0556 36.7022 45.6135 37.0374 44.1489 36.8039C40.9049 36.2867 38.681 33.2193 39.1982 29.9753C39.2459 29.6761 39.3069 29.3951 39.4018 29.1035C40.2789 26.3366 43.0846 24.5394 46.0294 25.0089C49.2734 25.5261 51.4973 28.5935 50.9776 31.8533Z", fill: "currentfill" })), "e");
var o5 = /* @__PURE__ */ __name((e44) => /* @__PURE__ */ e42.createElement("svg", { id: "logomark", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e44 }, /* @__PURE__ */ e42.createElement("path", { d: "M2.25 14.25V3C2.25 2.80109 2.32902 2.61032 2.46967 2.46967C2.61032 2.32902 2.80109 2.25 3 2.25H9.75C9.94891 2.25 10.1397 2.32902 10.2803 2.46967C10.421 2.61032 10.5 2.80109 10.5 3V9H12C12.3978 9 12.7794 9.15804 13.0607 9.43934C13.342 9.72064 13.5 10.1022 13.5 10.5V13.5C13.5 13.6989 13.579 13.8897 13.7197 14.0303C13.8603 14.171 14.0511 14.25 14.25 14.25C14.4489 14.25 14.6397 14.171 14.7803 14.0303C14.921 13.8897 15 13.6989 15 13.5V8.25H13.5C13.3011 8.25 13.1103 8.17098 12.9697 8.03033C12.829 7.88968 12.75 7.69891 12.75 7.5V4.8105L11.5072 3.56775L12.5677 2.50725L16.2802 6.21975C16.35 6.2893 16.4053 6.37195 16.443 6.46295C16.4807 6.55395 16.5001 6.6515 16.5 6.75V13.5C16.5 14.0967 16.2629 14.669 15.841 15.091C15.419 15.5129 14.8467 15.75 14.25 15.75C13.6533 15.75 13.081 15.5129 12.659 15.091C12.2371 14.669 12 14.0967 12 13.5V10.5H10.5V14.25H11.25V15.75H1.5V14.25H2.25ZM3.75 3.75V8.25H9V3.75H3.75Z", fill: "currentcolor" })), "o");
var t18 = /* @__PURE__ */ __name((e44) => /* @__PURE__ */ e42.createElement("svg", { id: "magic-wand", viewBox: "0 0 22 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e44 }, /* @__PURE__ */ e42.createElement("g", { clipPath: "url(#clip0_464_355)" }, /* @__PURE__ */ e42.createElement("path", { d: "M8.90674 9.02367L8.05736 11.748L7.23705 9.02367L4.51267 8.1743L7.23705 7.35398L8.05736 4.59961L8.90674 7.35398L11.6311 8.1743L8.90674 9.02367ZM13.6533 7.5293L13.2427 8.90648L12.7739 7.5293L11.4258 7.08961L12.7739 6.67898L13.2427 5.33086L13.6533 6.67898L15.0014 7.08961L13.6533 7.5293ZM0.263923 22.5002L17.0508 6.21117C17.168 6.06492 17.3442 5.9768 17.5486 5.9768C17.812 5.94773 18.0764 6.03586 18.2808 6.24023C18.3689 6.2993 18.4861 6.41648 18.6614 6.56273C18.9839 6.85617 19.3355 7.20773 19.5989 7.5593C19.7161 7.73555 19.7752 7.8818 19.7752 8.02805C19.8042 8.32148 19.7161 8.58492 19.5408 8.76023L2.75392 25.1084C2.60767 25.2546 2.43142 25.3137 2.22611 25.3427C1.96267 25.3718 1.6983 25.2837 1.49392 25.0793C1.4058 24.9912 1.28861 24.903 1.1133 24.7277C0.790798 24.4643 0.439236 24.1127 0.204861 23.7312C0.087673 23.5549 0.0286105 23.3796 -0.000451962 23.2334C-0.0295145 22.9399 0.0586105 22.7055 0.262986 22.5012L0.263923 22.5002ZM13.7405 10.6643L14.9714 11.9243L18.8677 8.14523L17.6367 6.85617L13.7405 10.6643ZM5.56736 12.334L5.18674 13.6821L4.77611 12.334L3.42799 11.8943L4.77611 11.4837L5.18674 10.1065L5.56736 11.4837L6.97361 11.8943L5.56736 12.334ZM19.2192 11.3093L19.6589 12.6865L21.007 13.0971L19.6589 13.5368L19.2192 14.8849L18.7795 13.5368L17.4314 13.0971L18.7795 12.6865L19.2192 11.3093Z", fill: "currentcolor" })), /* @__PURE__ */ e42.createElement("defs", null, /* @__PURE__ */ e42.createElement("clipPath", { id: "clip0_464_355" }, /* @__PURE__ */ e42.createElement("rect", { width: 22, height: 30, fill: "currentcolor" })))), "t");
var t19 = /* @__PURE__ */ __name((l9) => /* @__PURE__ */ e42.createElement("svg", { id: "play", viewBox: "0 0 13 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...l9 }, /* @__PURE__ */ e42.createElement("g", { clipPath: "url(#clip0_464_79)" }, /* @__PURE__ */ e42.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.854492 0V12L11.3545 6L0.854492 0Z", fill: "currentcolor" })), /* @__PURE__ */ e42.createElement("defs", null, /* @__PURE__ */ e42.createElement("clipPath", { id: "clip0_464_79" }, /* @__PURE__ */ e42.createElement("rect", { width: 12, height: 12, fill: "currentcolor", transform: "translate(0.104492)" })))), "t");
var r2 = /* @__PURE__ */ __name((t31) => /* @__PURE__ */ e42.createElement("svg", { id: "plug", viewBox: "0 -11 64 64", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", "xmlns:sketch": "http://www.bohemiancoding.com/sketch/ns", fill: "currentcolor", ...t31 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("title", null, "Plug"), /* @__PURE__ */ e42.createElement("desc", null, "Created with Sketch."), /* @__PURE__ */ e42.createElement("defs", null), /* @__PURE__ */ e42.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd", "sketch:type": "MSPage" }, /* @__PURE__ */ e42.createElement("g", { id: "Plug", "sketch:type": "MSLayerGroup", transform: "translate(1.000000, 1.000000)", stroke: "currentcolor", strokeWidth: 2 }, /* @__PURE__ */ e42.createElement("path", { d: "M20.1,33.7 L14.4,39.4 C14,39.8 13.4,39.8 13,39.4 L11.6,38 C11.2,37.6 11.2,37 11.6,36.6 L17.3,30.9", id: "Shape", "sketch:type": "MSShapeGroup" }), /* @__PURE__ */ e42.createElement("path", { d: "M8.8,22.4 L3.1,28.1 C2.7,28.5 2.1,28.5 1.7,28.1 L0.3,26.7 C-0.1,26.3 -0.1,25.7 0.3,25.3 L6,19.6", id: "Shape", "sketch:type": "MSShapeGroup" }), /* @__PURE__ */ e42.createElement("path", { d: "M31.4,12.5 L33.6,10.3 C34,9.9 34,9.3 33.6,8.9 L30.8,6.1 C30.4,5.7 29.8,5.7 29.4,6.1 L27.2,8.3 C20.9,3 13.9,3.2 1.7,15.4 L24.3,38 C36.5,25.8 37.4,19.3 31.4,12.5 L31.4,12.5 Z", id: "Shape", "sketch:type": "MSShapeGroup" }), /* @__PURE__ */ e42.createElement("path", { d: "M32.2,7.5 L38.5,1.2 C38.5,1.2 42,-2.3 47,2.6 C51.9,7.5 55.9,7.9 62.1,1.6", id: "Shape", "sketch:type": "MSShapeGroup" }), /* @__PURE__ */ e42.createElement("path", { d: "M12.3,17.5 L22.2,27.4", id: "Shape", "sketch:type": "MSShapeGroup" }), /* @__PURE__ */ e42.createElement("path", { d: "M15.1,14.7 L25,24.6", id: "Shape", "sketch:type": "MSShapeGroup" }))))), "r");
var r3 = /* @__PURE__ */ __name((C10) => /* @__PURE__ */ e42.createElement("svg", { id: "search", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...C10 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("path", { d: "M10.77 18.3C9.2807 18.3 7.82485 17.8584 6.58655 17.031C5.34825 16.2036 4.38311 15.0275 3.81318 13.6516C3.24325 12.2757 3.09413 10.7616 3.38468 9.30096C3.67523 7.84029 4.39239 6.49857 5.44548 5.44548C6.49857 4.39239 7.84029 3.67523 9.30096 3.38468C10.7616 3.09413 12.2757 3.24325 13.6516 3.81318C15.0275 4.38311 16.2036 5.34825 17.031 6.58655C17.8584 7.82485 18.3 9.2807 18.3 10.77C18.3 11.7588 18.1052 12.738 17.7268 13.6516C17.3484 14.5652 16.7937 15.3953 16.0945 16.0945C15.3953 16.7937 14.5652 17.3484 13.6516 17.7268C12.738 18.1052 11.7588 18.3 10.77 18.3ZM10.77 4.74999C9.58331 4.74999 8.42327 5.10189 7.43657 5.76118C6.44988 6.42046 5.68084 7.35754 5.22672 8.45389C4.77259 9.55025 4.65377 10.7566 4.88528 11.9205C5.11679 13.0844 5.68824 14.1535 6.52735 14.9926C7.36647 15.8317 8.43556 16.4032 9.59945 16.6347C10.7633 16.8662 11.9697 16.7474 13.0661 16.2933C14.1624 15.8391 15.0995 15.0701 15.7588 14.0834C16.4181 13.0967 16.77 11.9367 16.77 10.75C16.77 9.15869 16.1379 7.63257 15.0126 6.50735C13.8874 5.38213 12.3613 4.74999 10.77 4.74999Z", fill: "currentcolor" }), /* @__PURE__ */ e42.createElement("path", { d: "M20 20.75C19.9015 20.7504 19.8038 20.7312 19.7128 20.6934C19.6218 20.6557 19.5392 20.6001 19.47 20.53L15.34 16.4C15.2075 16.2578 15.1354 16.0697 15.1388 15.8754C15.1422 15.6811 15.221 15.4958 15.3584 15.3583C15.4958 15.2209 15.6812 15.1422 15.8755 15.1388C16.0698 15.1354 16.2578 15.2075 16.4 15.34L20.53 19.47C20.6704 19.6106 20.7493 19.8012 20.7493 20C20.7493 20.1987 20.6704 20.3893 20.53 20.53C20.4608 20.6001 20.3782 20.6557 20.2872 20.6934C20.1962 20.7312 20.0985 20.7504 20 20.75Z", fill: "currentcolor" }))), "r");
var t20 = /* @__PURE__ */ __name((e44) => /* @__PURE__ */ e42.createElement("svg", { id: "telegram", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e44 }, /* @__PURE__ */ e42.createElement("path", { d: "M15.4971 6.58466C15.5015 6.58466 15.5074 6.58466 15.5132 6.58466C15.6659 6.58466 15.8076 6.63214 15.9237 6.71394L15.9215 6.71248C16.0062 6.78626 16.0632 6.88997 16.0771 7.00684V7.00903C16.0917 7.09814 16.0997 7.2004 16.0997 7.30485C16.0997 7.35232 16.0983 7.39907 16.0946 7.44582V7.43924C15.9303 9.16959 15.2174 13.3658 14.8551 15.3029C14.7017 16.1231 14.4001 16.3977 14.1079 16.424C13.4732 16.4832 12.9911 16.0048 12.3761 15.6016C11.4134 14.9698 10.8693 14.5768 9.93506 13.9611C8.85478 13.2504 9.55525 12.8582 10.1703 12.2198C10.3317 12.0518 13.1299 9.50631 13.1847 9.2755C13.1876 9.26162 13.189 9.24628 13.189 9.23021C13.189 9.17324 13.1679 9.12138 13.1335 9.08194C13.0956 9.05711 13.0481 9.04323 12.9984 9.04323C12.9655 9.04323 12.9341 9.0498 12.9049 9.06076L12.9064 9.06003C12.81 9.08194 11.2722 10.0982 8.29309 12.1088C7.96806 12.3651 7.55757 12.5273 7.11056 12.5463H7.10618C6.47291 12.4696 5.89807 12.3286 5.35246 12.1278L5.40651 12.1453C4.72138 11.9218 4.17722 11.8042 4.22397 11.4258C4.24881 11.2291 4.52003 11.0278 5.03765 10.8218C8.22614 9.43254 10.3524 8.51684 11.4163 8.0747C12.5901 7.45166 13.9509 6.93891 15.3817 6.60657L15.4964 6.58393L15.4971 6.58466ZM10.9744 0C4.91056 0.0146082 0 4.93393 0 11C0 17.0748 4.92444 22 11 22C17.0756 22 22 17.0756 22 11C22 4.93393 17.0894 0.0146082 11.027 0H11.0256C11.0085 0 10.9915 0 10.9744 0Z", fill: "currentcolor" })), "t");
var C8 = /* @__PURE__ */ __name((t31) => /* @__PURE__ */ e42.createElement("svg", { id: "thunder", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t31 }, /* @__PURE__ */ e42.createElement("path", { d: "M11.5 13.8H10.1299C8.72143 13.8 8.01721 13.8 7.72228 13.3385C7.42735 12.8769 7.72321 12.2379 8.31493 10.9597L11.0463 5.06006C11.4205 4.25182 11.6075 3.8477 11.8038 3.89091C12 3.93413 12 4.37946 12 5.27013V9.7C12 9.9357 12 10.0536 12.0732 10.1268C12.1464 10.2 12.2643 10.2 12.5 10.2H13.8701C15.2786 10.2 15.9828 10.2 16.2777 10.6615C16.5726 11.1231 16.2768 11.7621 15.6851 13.0402L12.9537 18.9399C12.5795 19.7482 12.3925 20.1523 12.1962 20.1091C12 20.0659 12 19.6205 12 18.7299V14.3C12 14.0643 12 13.9464 11.9268 13.8732C11.8536 13.8 11.7357 13.8 11.5 13.8Z", fill: "currentcolor" })), "C");
var l4 = /* @__PURE__ */ __name((t31) => /* @__PURE__ */ e42.createElement("svg", { id: "twitter", viewBox: "0 0 20 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t31 }, /* @__PURE__ */ e42.createElement("g", { clipPath: "url(#clip0_444_865)" }, /* @__PURE__ */ e42.createElement("path", { d: "M0.0571313 0.0441551C0.0489346 0.0564499 0.712869 0.962187 1.52844 2.05235C2.34402 3.14252 4.07762 5.46219 5.3809 7.20399L7.74975 10.372L7.59812 10.5442C7.51205 10.6384 5.77025 12.5196 3.72926 14.7245C1.68828 16.9335 0.0120493 18.7532 0.00795094 18.7737C-0.000245777 18.7942 0.356312 18.8105 0.868607 18.8064L1.74156 18.8024L2.02844 18.4868C2.18828 18.3146 3.67189 16.7122 5.32762 14.9212C6.98336 13.1302 8.385 11.6138 8.44238 11.5483L8.54484 11.4294L9.36451 12.5278C9.81533 13.1302 11.0571 14.7942 12.1227 16.2204L14.0653 18.8105H17.0366C19.508 18.8105 20.0039 18.8024 19.9875 18.7573C19.9752 18.7245 19.2211 17.7081 18.3112 16.4909C17.4014 15.2778 16.3604 13.8843 15.9998 13.4007C15.635 12.9171 14.5653 11.4786 13.6145 10.2122C12.6637 8.9417 11.885 7.88432 11.885 7.86792C11.885 7.83924 16.9096 2.38432 18.6186 0.560549L19.1063 0.0400562H18.2088L17.3153 0.0441551L16.2702 1.1753C15.6965 1.79825 14.2907 3.32284 13.1432 4.55645L11.0653 6.80235L8.54484 3.4335L6.02025 0.0605488L3.04893 0.0400562C1.41369 0.0277615 0.065328 0.0318604 0.0571313 0.0441551ZM7.09812 3.6753C8.06943 4.97858 9.56943 6.98268 10.4301 8.13432C11.2907 9.28186 13.2006 11.8392 14.676 13.8105C16.1514 15.786 17.3727 17.4212 17.3932 17.4499C17.4178 17.4868 17.1268 17.4991 16.0653 17.4991H14.7088L12.0202 13.9007C5.81533 5.60973 2.68418 1.4212 2.6473 1.35973C2.6227 1.32284 2.90139 1.31055 3.97107 1.31055H5.32762L7.09812 3.6753Z", fill: "currentcolor" })), /* @__PURE__ */ e42.createElement("defs", null, /* @__PURE__ */ e42.createElement("clipPath", { id: "clip0_444_865" }, /* @__PURE__ */ e42.createElement("rect", { width: 20, height: 18.8115, fill: "white" })))), "l");
var t21 = /* @__PURE__ */ __name((r12) => /* @__PURE__ */ e42.createElement("svg", { id: "user-plus", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r12 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("path", { d: "M14.9999 15.2547C13.8661 14.4638 12.4872 14 10.9999 14C7.40399 14 4.44136 16.7114 4.04498 20.2013C4.01693 20.4483 4.0029 20.5718 4.05221 20.6911C4.09256 20.7886 4.1799 20.8864 4.2723 20.9375C4.38522 21 4.52346 21 4.79992 21H9.94465M13.9999 19.2857L15.7999 21L19.9999 17M14.9999 7C14.9999 9.20914 13.2091 11 10.9999 11C8.79078 11 6.99992 9.20914 6.99992 7C6.99992 4.79086 8.79078 3 10.9999 3C13.2091 3 14.9999 4.79086 14.9999 7Z", stroke: "currentcolor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }))), "t");
var t22 = /* @__PURE__ */ __name((r12) => /* @__PURE__ */ e42.createElement("svg", { id: "wallet", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r12 }, /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ e42.createElement("path", { d: "M6 8H10", stroke: "currentcolor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e42.createElement("path", { d: "M20.8333 9H18.2308C16.4465 9 15 10.3431 15 12C15 13.6569 16.4465 15 18.2308 15H20.8333C20.9167 15 20.9583 15 20.9935 14.9979C21.5328 14.965 21.9623 14.5662 21.9977 14.0654C22 14.0327 22 13.994 22 13.9167V10.0833C22 10.006 22 9.96726 21.9977 9.9346C21.9623 9.43384 21.5328 9.03496 20.9935 9.00214C20.9583 9 20.9167 9 20.8333 9Z", stroke: "currentcolor", strokeWidth: 1.5 }), /* @__PURE__ */ e42.createElement("path", { d: "M20.965 9C20.8873 7.1277 20.6366 5.97975 19.8284 5.17157C18.6569 4 16.7712 4 13 4L10 4C6.22876 4 4.34315 4 3.17157 5.17157C2 6.34315 2 8.22876 2 12C2 15.7712 2 17.6569 3.17157 18.8284C4.34315 20 6.22876 20 10 20H13C16.7712 20 18.6569 20 19.8284 18.8284C20.6366 18.0203 20.8873 16.8723 20.965 15", stroke: "currentcolor", strokeWidth: 1.5 }), /* @__PURE__ */ e42.createElement("path", { d: "M17.9912 12H18.0002", stroke: "currentcolor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }))), "t");
var ps = /* @__PURE__ */ __name(({ svg: s7, className: e44, ...r12 }) => {
  const t31 = x2(`../../assets/svgs/${s7}.svg`);
  return /* @__PURE__ */ e42__default.createElement(t31, { className: e44, ...r12 });
}, "ps");
function x2(s7) {
  switch (s7) {
    case "../../assets/svgs/alert-octagon":
    case "../../assets/svgs/alert-octagon.svg":
      return t3;
    case "../../assets/svgs/arrow-left":
    case "../../assets/svgs/arrow-left.svg":
      return t4;
    case "../../assets/svgs/arrow-right":
    case "../../assets/svgs/arrow-right.svg":
      return l2;
    case "../../assets/svgs/bolt":
    case "../../assets/svgs/bolt.svg":
      return C;
    case "../../assets/svgs/cancel":
    case "../../assets/svgs/cancel.svg":
      return t6;
    case "../../assets/svgs/check-circle":
    case "../../assets/svgs/check-circle.svg":
      return t7;
    case "../../assets/svgs/check":
    case "../../assets/svgs/check.svg":
      return t8;
    case "../../assets/svgs/chevron-down":
    case "../../assets/svgs/chevron-down.svg":
      return t9;
    case "../../assets/svgs/cloud-download":
    case "../../assets/svgs/cloud-download.svg":
      return t10;
    case "../../assets/svgs/copy":
    case "../../assets/svgs/copy.svg":
      return t11;
    case "../../assets/svgs/discord":
    case "../../assets/svgs/discord.svg":
      return t12;
    case "../../assets/svgs/double-arrow-down":
    case "../../assets/svgs/double-arrow-down.svg":
      return o3;
    case "../../assets/svgs/edit-off":
    case "../../assets/svgs/edit-off.svg":
      return t13;
    case "../../assets/svgs/error-circle":
    case "../../assets/svgs/error-circle.svg":
      return t14;
    case "../../assets/svgs/handshake":
    case "../../assets/svgs/handshake.svg":
      return t15;
    case "../../assets/svgs/info-circle":
    case "../../assets/svgs/info-circle.svg":
      return C4;
    case "../../assets/svgs/link-out":
    case "../../assets/svgs/link-out.svg":
      return t16;
    case "../../assets/svgs/link-round":
    case "../../assets/svgs/link-round.svg":
      return l3;
    case "../../assets/svgs/lock-alt":
    case "../../assets/svgs/lock-alt.svg":
      return t17;
    case "../../assets/svgs/lock":
    case "../../assets/svgs/lock.svg":
      return o4;
    case "../../assets/svgs/logo":
    case "../../assets/svgs/logo.svg":
      return e17;
    case "../../assets/svgs/logomark":
    case "../../assets/svgs/logomark.svg":
      return o5;
    case "../../assets/svgs/magic-wand":
    case "../../assets/svgs/magic-wand.svg":
      return t18;
    case "../../assets/svgs/play":
    case "../../assets/svgs/play.svg":
      return t19;
    case "../../assets/svgs/plug":
    case "../../assets/svgs/plug.svg":
      return r2;
    case "../../assets/svgs/search":
    case "../../assets/svgs/search.svg":
      return r3;
    case "../../assets/svgs/telegram":
    case "../../assets/svgs/telegram.svg":
      return t20;
    case "../../assets/svgs/thunder":
    case "../../assets/svgs/thunder.svg":
      return C8;
    case "../../assets/svgs/twitter":
    case "../../assets/svgs/twitter.svg":
      return l4;
    case "../../assets/svgs/user-plus":
    case "../../assets/svgs/user-plus.svg":
      return t21;
    case "../../assets/svgs/wallet":
    case "../../assets/svgs/wallet.svg":
      return t22;
    default:
      throw new Error("Cann't found module: " + s7);
  }
}
__name(x2, "x");
var c4 = /* @__PURE__ */ __name(({
  text: t31,
  className: l9,
  fullScreen: a5,
  spinnerClass: i5,
  ...n7
}) => /* @__PURE__ */ e42__default.createElement(
  "div",
  {
    className: c(
      "flex gap-3 items-center justify-center h-full text-xs",
      { "fixed inset-0": a5 },
      l9
    )
  },
  /* @__PURE__ */ e42__default.createElement(
    "svg",
    {
      id: "spinner",
      "aria-hidden": "true",
      viewBox: "0 0 100 101",
      xmlns: "http://www.w3.org/2000/svg",
      className: c(
        "fill-gray-75 dark:fill-gray-400 w-6 h-6 animate-spin",
        i5
      ),
      ...n7
    },
    /* @__PURE__ */ e42__default.createElement(
      "path",
      {
        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
        fill: "currentfill"
      }
    ),
    /* @__PURE__ */ e42__default.createElement(
      "path",
      {
        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
        fill: "currentcolor"
      }
    )
  ),
  t31 && /* @__PURE__ */ e42__default.createElement("p", { className: "text-gray-100" }, t31)
), "c");

// ../shared/dist/components/ui/button/index.js
var u2 = e42__default.forwardRef(
  (l9, i5) => {
    const {
      children: d5,
      loading: t31,
      disabled: a5,
      fullwidth: m5,
      className: c11,
      variant: r12,
      prependIcon: n7,
      appendIcon: s7,
      ...g7
    } = l9, p4 = `h-[2.85rem] relative bg-primary px-8 relative rounded-60 
      text-sm text-white font-semibold dark:text-gray-500 border-none
      flex items-center justify-center gap-2 outline-none overflow-hidden`;
    return /* @__PURE__ */ e42__default.createElement(
      "button",
      {
        ref: i5,
        disabled: t31 || a5,
        className: c(
          p4,
          {
            "w-full": m5,
            "bg-transparent px-0 py-0 h-fit w-fit": r12 === "ghost",
            "bg-gray-500 text-white dark:text-white": r12 === "dark",
            "bg-gray-75 dark:bg-gray-200 text-gray-500 dark:text-white": r12 === "secondary" || a5 || t31,
            "pointer-events-none": t31 || a5,
            "opacity-40 text-gray-100 dark:text-gray-100": a5
          },
          c11
        ),
        ...g7
      },
      n7 && /* @__PURE__ */ e42__default.createElement(ps, { svg: n7, className: "w-4 h-4" }),
      d5,
      s7 && /* @__PURE__ */ e42__default.createElement(ps, { svg: s7, className: "w-4 h-4" }),
      t31 && /* @__PURE__ */ e42__default.createElement("span", { className: "absolute inset-0 bg-gray-75 dark:bg-gray-200 pointer-events-none" }, /* @__PURE__ */ e42__default.createElement(
        c4,
        {
          text: "Please wait...",
          className: " font-normal",
          spinnerClass: "w-4 h-4 fill-gray-100 dark:text- dark:fill-gray-100"
        }
      ))
    );
  }
);
var g = e42__default.forwardRef(
  (l9, s7) => {
    const {
      id: t31,
      loading: n7,
      disabled: a5,
      fullwidth: d5,
      className: o12,
      inputClassName: m5,
      label: i5,
      secondaryLabel: c11,
      renderBottomRight: b8,
      ...x4
    } = l9;
    return /* @__PURE__ */ e42__default.createElement(
      "div",
      {
        className: c(
          "border border-solid border-gray-90 dark:border-gray-200 py-3 px-4 bg-gray-75 dark:bg-gray-500 rounded-22 flex flex-col justify-between h-[5.25rem]",
          {
            "w-full": d5,
            "opacity-50 pointer-events-none": a5
          },
          o12
        )
      },
      /* @__PURE__ */ e42__default.createElement("div", { className: " flex justify-between items-center" }, /* @__PURE__ */ e42__default.createElement("label", { htmlFor: t31, className: "text-xs text-gray-100" }, i5), /* @__PURE__ */ e42__default.createElement("span", { className: "text-xs text-gray-100" }, c11)),
      /* @__PURE__ */ e42__default.createElement("div", { className: "flex justify-between items-end" }, /* @__PURE__ */ e42__default.createElement(
        "input",
        {
          id: t31,
          ref: s7,
          disabled: n7 || a5,
          className: c(
            "w-full border-none outline-none text-gray-200 dark:text-white bg-transparent text-[1.625rem] font-semibold placeholder-gray-100 placeholder:dark:text-gray-400",
            m5
          ),
          ...x4
        }
      ), /* @__PURE__ */ e42__default.createElement("div", { className: "shrink-0" }, b8))
    );
  }
);
var w = /* @__PURE__ */ __name(({
  children: t31,
  content: l9,
  align: m5,
  side: o12,
  open: d5,
  disabled: c11,
  className: s7,
  triggerClassname: f8,
  underline: p4 = true,
  usePortal: u6 = true,
  customParent: a5
}) => {
  const i5 = useRef(null);
  return c11 ? t31 : /* @__PURE__ */ e42__default.createElement(r5.Provider, { delayDuration: 300 }, /* @__PURE__ */ e42__default.createElement(r5.Root, { open: d5 }, /* @__PURE__ */ e42__default.createElement(
    r5.Trigger,
    {
      asChild: true,
      className: c(
        "decoration-dashed cursor-pointer underline-offset-2",
        {
          underline: p4
        },
        f8
      )
    },
    /* @__PURE__ */ e42__default.createElement("span", { ref: i5 }, t31)
  ), /* @__PURE__ */ e42__default.createElement(
    r5.Portal,
    {
      container: a5 ? a5.current : u6 ? void 0 : i5.current
    },
    /* @__PURE__ */ e42__default.createElement(
      r5.Content,
      {
        align: m5,
        side: o12,
        sideOffset: 2,
        className: c(
          "flexy-portal-content min-w-[5rem] min-h-[1.5rem] border border-gray-75 dark:border-none border-solid bg-white px-3 py-2 dark:bg-gray-500 overflow-hidden z-50 text-xs rounded-[5px]",
          {
            "mt-1": o12 !== "bottom"
          },
          s7
        )
      },
      l9,
      /* @__PURE__ */ e42__default.createElement(r5.Arrow, { className: "dark:text-gray-500 text-white fill-white dark:fill-gray-500" })
    )
  )));
}, "w");
var A = /* @__PURE__ */ __name(({
  placeholder: f8,
  renderOption: l9,
  renderValue: c11,
  label: n7,
  disabled: p4,
  options: m5,
  onValueChange: y,
  className: i5,
  hideSelectIcon: E2,
  contentClassname: x4,
  disallowChange: s7,
  align: b8 = "start",
  variant: u6 = "default",
  usePortal: v2 = true,
  value: d5
}) => {
  const [w3, N] = useState(false), g7 = useRef(null);
  return /* @__PURE__ */ e42__default.createElement(
    t23.Root,
    {
      onValueChange: y,
      onOpenChange: (a5) => N(a5),
      disabled: p4,
      value: d5
    },
    /* @__PURE__ */ e42__default.createElement(
      t23.Trigger,
      {
        asChild: true,
        "aria-label": n7,
        className: c(
          "outline-none w-full",
          {
            "cursor-not-allowed pointer-events-none": s7
          },
          i5
        )
      },
      /* @__PURE__ */ e42__default.createElement(
        u2,
        {
          variant: "secondary",
          ref: g7,
          className: c(
            "px-5 justify-start",
            {
              "p-0 rounded-none bg-transparent": u6 === "ghost"
            },
            i5
          )
        },
        c11 && d5 ? /* @__PURE__ */ e42__default.createElement(t23.Value, { asChild: true, className: "h-full" }, c11()) : /* @__PURE__ */ e42__default.createElement(
          t23.Value,
          {
            className: "h-full flex flex-col justify-stretch text-gray-100 font-normal",
            placeholder: /* @__PURE__ */ e42__default.createElement("span", { className: "text-gray-100 font-normal" }, f8)
          }
        ),
        !E2 && /* @__PURE__ */ e42__default.createElement(
          ps,
          {
            svg: s7 ? "check-circle" : "chevron-down",
            className: c("absolute w-3 h-3 right-6 transition-all", {
              "rotate-180": w3,
              "w-6 h-6 text-gray-200 dark:text-gray-100": s7,
              "right-0": u6 === "ghost"
            })
          }
        )
      )
    ),
    /* @__PURE__ */ e42__default.createElement(
      t23.Portal,
      {
        container: v2 ? void 0 : g7.current
      },
      /* @__PURE__ */ e42__default.createElement(
        t23.Content,
        {
          align: b8,
          position: "popper",
          style: { width: "var(--radix-popper-anchor-width)" },
          className: c(
            "flexy-portal-content min-w-[16rem] border border-solid border-gray-90 rounded-xl mb-2 bg-white py-2 dark:bg-gray-400 rounded-22 overflow-hidden z-[70] data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1 font-normal dark:border-gray-200",
            x4
          )
        },
        /* @__PURE__ */ e42__default.createElement(o6.Root, null, /* @__PURE__ */ e42__default.createElement(t23.Viewport, { asChild: true }, /* @__PURE__ */ e42__default.createElement(
          o6.Viewport,
          {
            style: { overflowY: void 0 },
            className: "w-full h-full max-h-[16rem]"
          },
          m5.length ? /* @__PURE__ */ e42__default.createElement(t23.Group, null, n7 && /* @__PURE__ */ e42__default.createElement(t23.Label, null, n7), m5.map((a5, k3) => /* @__PURE__ */ e42__default.createElement(
            t23.Item,
            {
              key: k3,
              className: c(
                "relative outline-none flex items-center gap-3 cursor-pointer transition-all",
                {
                  "px-4 py-3 hover:bg-gray-75 dark:hover:bg-gray-400 ": !l9
                }
              ),
              value: a5.value
            },
            (l9 == null ? void 0 : l9(a5)) ?? /* @__PURE__ */ e42__default.createElement(t23.ItemText, null, a5.title),
            /* @__PURE__ */ e42__default.createElement(t23.ItemIndicator, { className: "absolute right-4" }, /* @__PURE__ */ e42__default.createElement(ps, { svg: "check-circle", className: "w-5 h-5" }))
          ))) : /* @__PURE__ */ e42__default.createElement("div", { className: "h-40 p-6 grid place-items-center" }, /* @__PURE__ */ e42__default.createElement("p", { className: "text-gray-100 text-sm" }, "No Items Available"))
        )), /* @__PURE__ */ e42__default.createElement(
          o6.Scrollbar,
          {
            orientation: "vertical",
            className: "w-[0.38rem] touch-none"
          },
          /* @__PURE__ */ e42__default.createElement(o6.Thumb, { className: "bg-gray-90 dark:bg-gray-300 flex-grow relative rounded-30 mr-[0.1rem]" })
        ))
      )
    )
  );
}, "A");
e42.forwardRef(({ className: t31, ...a5 }, r12) => /* @__PURE__ */ e42.createElement(
  o7.List,
  {
    ...a5,
    ref: r12,
    className: c(
      "inline-flex items-center justify-center bg-muted text-muted-foreground h-[3.2rem] max-sm:h-[2.85rem]",
      t31
    )
  }
));
e42.forwardRef(({ className: t31, ...a5 }, r12) => /* @__PURE__ */ e42.createElement(
  o7.Trigger,
  {
    ...a5,
    ref: r12,
    className: c(
      "capitalize h-full max-sm:font-medium max-sm:text-xs rounded-none font-medium relative text-sm flex items-center justify-center gap-2 outline-none overflow-hidden bg-transparent text-gray-500 dark:text-white data-[state=active]:bg-primary data-[state=active]:dark:bg-primary data-[state=active]:text-white data-[state=active]:dark:text-gray-500 data-[state=active]:border-none border-b border-solid border-gray-75 dark:border-gray-200",
      t31
    )
  }
));
e42.forwardRef(({ className: t31, ...a5 }, r12) => /* @__PURE__ */ e42.createElement(
  o7.Content,
  {
    ...a5,
    ref: r12,
    className: c("outline-none w-full relative", t31)
  }
));

// ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i5 = 1; i5 < arguments.length; i5++) {
      var source = arguments[i5];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
__name(_extends, "_extends");

// ../../node_modules/@radix-ui/primitive/dist/index.mjs
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return /* @__PURE__ */ __name(function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented)
      return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  }, "handleEvent");
}
__name($e42e1063c40fb3ef$export$b9ecd428b558ff10, "$e42e1063c40fb3ef$export$b9ecd428b558ff10");
function $6ed0406888f73fc4$var$setRef(ref, value) {
  if (typeof ref === "function")
    ref(value);
  else if (ref !== null && ref !== void 0)
    ref.current = value;
}
__name($6ed0406888f73fc4$var$setRef, "$6ed0406888f73fc4$var$setRef");
function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef(ref, node)
  );
}
__name($6ed0406888f73fc4$export$43e446d32b3d21af, "$6ed0406888f73fc4$export$43e446d32b3d21af");
function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
  return useCallback($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}
__name($6ed0406888f73fc4$export$c7b2cbe3552a0d05, "$6ed0406888f73fc4$export$c7b2cbe3552a0d05");
function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ createContext(defaultContext);
    const index = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider2(props) {
      const { scope, children, ...context } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
      const value = useMemo(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ createElement(Context.Provider, {
        value
      }, children);
    }
    __name(Provider2, "Provider");
    function useContext$1(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
      const context = useContext(Context);
      if (context)
        return context;
      if (defaultContext !== void 0)
        return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    __name(useContext$1, "useContext");
    Provider2.displayName = rootComponentName + "Provider";
    return [
      Provider2,
      useContext$1
    ];
  }
  __name($c512c27ab02ef895$export$fd42f52fd3ae1109, "$c512c27ab02ef895$export$fd42f52fd3ae1109");
  const createScope = /* @__PURE__ */ __name(() => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ createContext(defaultContext);
    });
    return /* @__PURE__ */ __name(function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return useMemo(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    }, "useScope");
  }, "createScope");
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae1109,
    $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
  ];
}
__name($c512c27ab02ef895$export$50c7b4e9d9f19c1, "$c512c27ab02ef895$export$50c7b4e9d9f19c1");
function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1)
    return baseScope;
  const createScope1 = /* @__PURE__ */ __name(() => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return /* @__PURE__ */ __name(function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return useMemo(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    }, "useComposedScopes");
  }, "createScope1");
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}
__name($c512c27ab02ef895$var$composeContextScopes, "$c512c27ab02ef895$var$composeContextScopes");
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  });
  return useMemo(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}
__name($b1b2314f5f9a1d84$export$25bec8c6f54ee79a, "$b1b2314f5f9a1d84$export$25bec8c6f54ee79a");

// ../../node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
function $71cd76cc60e0454e$export$6f32135080cb4c3({ prop, defaultProp, onChange = /* @__PURE__ */ __name(() => {
}, "onChange") }) {
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
    defaultProp,
    onChange
  });
  const isControlled = prop !== void 0;
  const value1 = isControlled ? prop : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
  const setValue = useCallback((nextValue) => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop) : nextValue;
      if (value !== prop)
        handleChange(value);
    } else
      setUncontrolledProp(nextValue);
  }, [
    isControlled,
    prop,
    setUncontrolledProp,
    handleChange
  ]);
  return [
    value1,
    setValue
  ];
}
__name($71cd76cc60e0454e$export$6f32135080cb4c3, "$71cd76cc60e0454e$export$6f32135080cb4c3");
function $71cd76cc60e0454e$var$useUncontrolledState({ defaultProp, onChange }) {
  const uncontrolledState = useState(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = useRef(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
  useEffect(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [
    value,
    prevValueRef,
    handleChange
  ]);
  return uncontrolledState;
}
__name($71cd76cc60e0454e$var$useUncontrolledState, "$71cd76cc60e0454e$var$useUncontrolledState");
function $010c2913dbd2fe3d$export$5cae361ad82dce8b(value) {
  const ref = useRef({
    value,
    previous: value
  });
  return useMemo(() => {
    if (ref.current.value !== value) {
      ref.current.previous = ref.current.value;
      ref.current.value = value;
    }
    return ref.current.previous;
  }, [
    value
  ]);
}
__name($010c2913dbd2fe3d$export$5cae361ad82dce8b, "$010c2913dbd2fe3d$export$5cae361ad82dce8b");
var $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? useLayoutEffect : () => {
};

// ../../node_modules/@radix-ui/react-use-size/dist/index.mjs
function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
  const [size, setSize] = useState(void 0);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (element) {
      setSize({
        width: element.offsetWidth,
        height: element.offsetHeight
      });
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries))
          return;
        if (!entries.length)
          return;
        const entry = entries[0];
        let width;
        let height;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({
          width,
          height
        });
      });
      resizeObserver.observe(element, {
        box: "border-box"
      });
      return () => resizeObserver.unobserve(element);
    } else
      setSize(void 0);
  }, [
    element
  ]);
  return size;
}
__name($db6c3485150b8e66$export$1ab7ae714698c4b8, "$db6c3485150b8e66$export$1ab7ae714698c4b8");
var $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  const childrenArray = Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map((child) => {
      if (child === slottable) {
        if (Children.count(newElement) > 1)
          return Children.only(null);
        return /* @__PURE__ */ isValidElement(newElement) ? newElement.props.children : null;
      } else
        return child;
    });
    return /* @__PURE__ */ createElement($5e63c961fc1ce211$var$SlotClone, _extends({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */ isValidElement(newElement) ? /* @__PURE__ */ cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */ createElement($5e63c961fc1ce211$var$SlotClone, _extends({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = "Slot";
var $5e63c961fc1ce211$var$SlotClone = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  if (/* @__PURE__ */ isValidElement(children))
    return /* @__PURE__ */ cloneElement(children, {
      ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
      ref: forwardedRef ? $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref) : children.ref
    });
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
var $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ __name(({ children }) => {
  return /* @__PURE__ */ createElement(Fragment, null, children);
}, "$5e63c961fc1ce211$export$d9f1ccf0bdb05d45");
function $5e63c961fc1ce211$var$isSlottable(child) {
  return /* @__PURE__ */ isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
__name($5e63c961fc1ce211$var$isSlottable, "$5e63c961fc1ce211$var$isSlottable");
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
  const overrideProps = {
    ...childProps
  };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue)
        overrideProps[propName] = (...args) => {
          childPropValue(...args);
          slotPropValue(...args);
        };
      else if (slotPropValue)
        overrideProps[propName] = slotPropValue;
    } else if (propName === "style")
      overrideProps[propName] = {
        ...slotPropValue,
        ...childPropValue
      };
    else if (propName === "className")
      overrideProps[propName] = [
        slotPropValue,
        childPropValue
      ].filter(Boolean).join(" ");
  }
  return {
    ...slotProps,
    ...overrideProps
  };
}
__name($5e63c961fc1ce211$var$mergeProps, "$5e63c961fc1ce211$var$mergeProps");

// ../../node_modules/@radix-ui/react-primitive/dist/index.mjs
var $8927f6f2acc4f386$var$NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node) => {
  const Node = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
    useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ createElement(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node
  };
}, {});

// ../../node_modules/@radix-ui/react-switch/dist/index.mjs
var $6be4966fd9bbc698$var$SWITCH_NAME = "Switch";
var [$6be4966fd9bbc698$var$createSwitchContext, $6be4966fd9bbc698$export$cf7f5f17f69cbd43] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($6be4966fd9bbc698$var$SWITCH_NAME);
var [$6be4966fd9bbc698$var$SwitchProvider, $6be4966fd9bbc698$var$useSwitchContext] = $6be4966fd9bbc698$var$createSwitchContext($6be4966fd9bbc698$var$SWITCH_NAME);
var $6be4966fd9bbc698$export$b5d5cf8927ab7262 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeSwitch, name, checked: checkedProp, defaultChecked, required, disabled, value = "on", onCheckedChange, ...switchProps } = props;
  const [button, setButton] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(
    forwardedRef,
    (node) => setButton(node)
  );
  const hasConsumerStoppedPropagationRef = useRef(false);
  const isFormControl = button ? Boolean(button.closest("form")) : true;
  const [checked = false, setChecked] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: checkedProp,
    defaultProp: defaultChecked,
    onChange: onCheckedChange
  });
  return /* @__PURE__ */ createElement($6be4966fd9bbc698$var$SwitchProvider, {
    scope: __scopeSwitch,
    checked,
    disabled
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends({
    type: "button",
    role: "switch",
    "aria-checked": checked,
    "aria-required": required,
    "data-state": $6be4966fd9bbc698$var$getState(checked),
    "data-disabled": disabled ? "" : void 0,
    disabled,
    value
  }, switchProps, {
    ref: composedRefs,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, (event) => {
      setChecked(
        (prevChecked) => !prevChecked
      );
      if (isFormControl) {
        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
        if (!hasConsumerStoppedPropagationRef.current)
          event.stopPropagation();
      }
    })
  })), isFormControl && /* @__PURE__ */ createElement($6be4966fd9bbc698$var$BubbleInput, {
    control: button,
    bubbles: !hasConsumerStoppedPropagationRef.current,
    name,
    value,
    checked,
    required,
    disabled,
    style: {
      transform: "translateX(-100%)"
    }
  }));
});
var $6be4966fd9bbc698$var$THUMB_NAME = "SwitchThumb";
var $6be4966fd9bbc698$export$4d07bf653ea69106 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeSwitch, ...thumbProps } = props;
  const context = $6be4966fd9bbc698$var$useSwitchContext($6be4966fd9bbc698$var$THUMB_NAME, __scopeSwitch);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({
    "data-state": $6be4966fd9bbc698$var$getState(context.checked),
    "data-disabled": context.disabled ? "" : void 0
  }, thumbProps, {
    ref: forwardedRef
  }));
});
var $6be4966fd9bbc698$var$BubbleInput = /* @__PURE__ */ __name((props) => {
  const { control, checked, bubbles = true, ...inputProps } = props;
  const ref = useRef(null);
  const prevChecked = $010c2913dbd2fe3d$export$5cae361ad82dce8b(checked);
  const controlSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(control);
  useEffect(() => {
    const input = ref.current;
    const inputProto = window.HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
    const setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", {
        bubbles
      });
      setChecked.call(input, checked);
      input.dispatchEvent(event);
    }
  }, [
    prevChecked,
    checked,
    bubbles
  ]);
  return /* @__PURE__ */ createElement("input", _extends({
    type: "checkbox",
    "aria-hidden": true,
    defaultChecked: checked
  }, inputProps, {
    tabIndex: -1,
    ref,
    style: {
      ...props.style,
      ...controlSize,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
}, "$6be4966fd9bbc698$var$BubbleInput");
function $6be4966fd9bbc698$var$getState(checked) {
  return checked ? "checked" : "unchecked";
}
__name($6be4966fd9bbc698$var$getState, "$6be4966fd9bbc698$var$getState");
var $6be4966fd9bbc698$export$be92b6f5f03c0fe9 = $6be4966fd9bbc698$export$b5d5cf8927ab7262;
var $6be4966fd9bbc698$export$6521433ed15a34db = $6be4966fd9bbc698$export$4d07bf653ea69106;
var l6 = e42.forwardRef(({ className: a5, ...i5 }, o12) => /* @__PURE__ */ e42.createElement(
  $6be4966fd9bbc698$export$be92b6f5f03c0fe9,
  {
    className: c(
      "peer inline-flex h-4 w-8 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-gray-500 data-[state=checked]:dark:bg-white data-[state=unchecked]:bg-gray-100",
      a5
    ),
    ...i5,
    ref: o12
  },
  /* @__PURE__ */ e42.createElement(
    $6be4966fd9bbc698$export$6521433ed15a34db,
    {
      className: c(
        "pointer-events-none block h-3 w-3 rounded-full bg-white dark:bg-gray-500 shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
      )
    }
  )
));
var t24 = atom(false);
var n2 = atom(false);
var e33 = atom([]);
var u3 = atom();
var o8 = atom(0);
var m = atom("");
var p2 = atom(false);
var g3 = atom(false);
var a3 = atom();
var c5 = atom();
var k = atom();
var v = atom();
var i3 = atom();
var T = atom();
var l7 = atom(false);
var f4 = atom(false);
var b3 = atom(false);
var h2 = atom(false);
var r6 = /* @__PURE__ */ __name(() => {
  o8.set(0), a3.set(void 0), c5.set(void 0), i3.set(void 0);
}, "r");
function useStore(store, opts = {}) {
  let subscribe = useCallback(
    (onChange) => opts.keys ? listenKeys(store, opts.keys, onChange) : store.listen(onChange),
    [opts.keys, store]
  );
  let get = store.get.bind(store);
  return useSyncExternalStore(subscribe, get, get);
}
__name(useStore, "useStore");
var d3 = {
  id: 2222,
  name: "Kava",
  network: "kava",
  nativeCurrency: {
    decimals: 18,
    name: "Kava",
    symbol: "KAVA"
  },
  rpcUrls: {
    public: { http: ["https://evm.kava.io"] },
    default: { http: ["https://evm.kava.io"] }
  },
  blockExplorers: {
    etherscan: { name: "KavaScan", url: "https://kavascan.com/" },
    default: { name: "KavaScan", url: "https://kavascan.com/" }
  }
};
var u4 = {
  id: 34443,
  name: "Mode",
  network: "mode",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    public: { http: ["https://mainnet.mode.network	"] },
    default: { http: ["https://mainnet.mode.network	"] }
  },
  blockExplorers: {
    etherscan: { name: "ModeScan", url: "https://modescan.io/" },
    default: { name: "ModeScan", url: "https://modescan.io/" }
  }
};
var m2 = {
  id: 81457,
  name: "Blast",
  network: "blast",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    public: { http: ["https://rpc.ankr.com/blast/"] },
    default: { http: ["https://rpc.ankr.com/blast/"] }
  },
  blockExplorers: {
    etherscan: { name: "BlastScan", url: "https://blastscan.io/" },
    default: { name: "BlastScan", url: "https://blastscan.io/" }
  }
};
var b4 = {
  id: 82,
  name: "Meter",
  network: "meter",
  nativeCurrency: {
    decimals: 18,
    name: "Meter",
    symbol: "MTR"
  },
  rpcUrls: {
    public: { http: ["https://rpc.meter.io"] },
    default: { http: ["https://rpc.meter.io"] }
  },
  blockExplorers: {
    etherscan: { name: "Meter Explorer", url: "https://explorer.meter.io/" },
    default: { name: "Meter Explorer", url: "https://explorer.meter.io/" }
  }
};
var U = [
  {
    ...arbitrum,
    rpcUrls: {
      ...arbitrum.rpcUrls,
      public: { http: ["https://rpc.ankr.com/arbitrum"] },
      default: { http: ["https://rpc.ankr.com/arbitrum"] }
    }
  },
  {
    ...avalanche,
    rpcUrls: {
      ...avalanche.rpcUrls,
      public: { http: ["https://rpc.ankr.com/avalanche"] },
      default: { http: ["https://rpc.ankr.com/avalanche"] }
    }
  },
  {
    ...base,
    rpcUrls: {
      ...base.rpcUrls,
      public: { http: ["https://rpc.ankr.com/base"] },
      default: { http: ["https://rpc.ankr.com/base"] }
    }
  },
  {
    ...bsc,
    rpcUrls: {
      ...bsc.rpcUrls,
      public: { http: ["https://rpc.ankr.com/bsc"] },
      default: { http: ["https://rpc.ankr.com/bsc"] }
    }
  },
  {
    ...mainnet,
    rpcUrls: {
      ...mainnet.rpcUrls,
      public: { http: ["https://rpc.ankr.com/eth"] },
      default: { http: ["https://rpc.ankr.com/eth"] }
    }
  },
  {
    ...scroll,
    rpcUrls: {
      ...scroll.rpcUrls,
      public: { http: ["https://rpc.ankr.com/scroll"] },
      default: { http: ["https://rpc.ankr.com/scroll"] }
    }
  },
  {
    ...optimism,
    rpcUrls: {
      ...optimism.rpcUrls,
      public: { http: ["https://rpc.ankr.com/optimism"] },
      default: { http: ["https://rpc.ankr.com/optimism"] }
    }
  },
  {
    ...linea,
    rpcUrls: {
      ...linea.rpcUrls,
      public: { http: ["https://rpc.ankr.com/linea"] },
      default: { http: ["https://rpc.ankr.com/linea"] }
    }
  },
  cronos,
  manta,
  d3,
  {
    ...polygon,
    rpcUrls: {
      ...polygon.rpcUrls,
      public: { http: ["https://rpc.ankr.com/polygon"] },
      default: { http: ["https://rpc.ankr.com/polygon"] }
    }
  },
  {
    ...fantom,
    rpcUrls: {
      ...fantom.rpcUrls,
      public: { http: ["https://rpc.ankr.com/fantom"] },
      default: { http: ["https://rpc.ankr.com/fantom"] }
    }
  },
  u4,
  {
    ...m2,
    rpcUrls: {
      ...m2.rpcUrls,
      public: { http: ["https://rpc.ankr.com/blast"] },
      default: { http: ["https://rpc.ankr.com/blast"] }
    }
  },
  b4
];
[
  mainnet.id,
  m2.id,
  arbitrum.id,
  base.id,
  u4.id,
  bsc.id,
  polygon.id,
  optimism.id,
  avalanche.id,
  manta.id,
  scroll.id,
  linea.id,
  fantom.id,
  cronos.id,
  d3.id,
  b4.id
];
var s4 = atom(U);
var c7 = atom(true);
var b5 = /* @__PURE__ */ __name((e44) => {
  const [o12, a5] = useState(), [r12, c11] = useState(), { publicClient: d5, walletClient: t31 } = useMemo(() => b(e44), [e44]);
  return useEffect(() => {
    async function m5() {
      try {
        const s7 = await t31.getChainId(), [p4] = await t31.getAddresses();
        a5(p4), c11(s7), c7.set(false);
      } catch {
        c7.set(true);
      }
    }
    __name(m5, "m");
    m5();
  }, [t31]), {
    chainId: r12,
    address: o12,
    publicClient: d5,
    walletClient: t31,
    switchNetwork: t31.switchChain,
    signTypedData: t31.signTypedData
  };
}, "b");

// ../shared/dist/constants/contracts/index.js
var r8 = "0x0fF280f8b350619E89aB58C15409326cb60188B5";

// ../shared/dist/abis/erc20ABI/index.js
var e35 = [
  {
    type: "event",
    name: "Approval",
    inputs: [
      {
        indexed: true,
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        name: "value",
        type: "uint256"
      }
    ]
  },
  {
    type: "event",
    name: "Transfer",
    inputs: [
      {
        indexed: true,
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        name: "value",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "allowance",
    stateMutability: "view",
    inputs: [
      {
        name: "owner",
        type: "address"
      },
      {
        name: "spender",
        type: "address"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "approve",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "spender",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  },
  {
    type: "function",
    name: "balanceOf",
    stateMutability: "view",
    inputs: [
      {
        name: "account",
        type: "address"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "decimals",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8"
      }
    ]
  },
  {
    type: "function",
    name: "name",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string"
      }
    ]
  },
  {
    type: "function",
    name: "symbol",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string"
      }
    ]
  },
  {
    type: "function",
    name: "totalSupply",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "transfer",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "recipient",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  },
  {
    type: "function",
    name: "transferFrom",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "sender",
        type: "address"
      },
      {
        name: "recipient",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  }
];

// ../shared/dist/abis/bridgeNativeABI/index.js
var t26 = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_toChainId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_toToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_minAmountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_deadline",
        type: "uint256"
      }
    ],
    name: "bridgeNative",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  }
];

// ../shared/dist/abis/usdtMainnetABI/index.js
var e36 = [
  {
    constant: false,
    inputs: [
      {
        name: "_spender",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  }
];
var P = /* @__PURE__ */ __name((d5, l9, u6, m5) => {
  const g7 = l9 ? `&widgetVersion=${l9}` : "", k3 = u6 ? `&iframeOrigin=${u6}` : "", v2 = d5 ? `/scan?walletAddress=${d5}${g7}${k3}` : null;
  d("/getInitData", {
    revalidateOnFocus: false,
    onSuccess(o12) {
      u3.set(o12);
    }
  });
  const { isLoading: p4, error: f8 } = d(v2, {
    revalidateOnFocus: false,
    onSuccess(o12) {
      const h5 = Object.entries(o12), t31 = h5.reduce((n7, [, s7]) => {
        const { tokens: e44, ...i5 } = s7, c11 = e44.map((r12) => ({
          ...r12,
          chainAttributes: i5,
          nativeTokenPrice: s7.nativeToken.price
        }));
        return n7.concat(c11).sort((r12, A2) => {
          const C10 = r12.usd;
          return A2.usd - C10;
        });
      }, []), T2 = h5.reduce((n7, [s7, e44]) => {
        const { nativeToken: i5 } = e44, c11 = {
          id: Number(s7),
          ...e44,
          nativeToken: {
            ...i5,
            decimals: 18,
            chain_id: Number(s7),
            chainAttributes: e44,
            address: "0x0000000000000000000000000000000000000000",
            type: "native"
          }
        };
        return [...n7, c11];
      }, []), $ = U.map((n7) => {
        const s7 = T2.find((e44) => e44.id === n7.id);
        return {
          ...s7,
          ...n7,
          iconUrl: s7 == null ? void 0 : s7.logo_url,
          iconBackground: s7 == null ? void 0 : s7.background_color
        };
      }).filter((n7) => !!n7.logo_url);
      if (s4.set($), !m5)
        e33.set(t31);
      else {
        const n7 = t31.findIndex((s7) => s7.address === m5);
        if (n7 !== -1) {
          const s7 = [...t31];
          s7.splice(n7, 1), e33.set([t31[n7]].concat(s7));
        } else
          e33.set(t31);
      }
      t31.length === 1 && a3.set(t31[0]);
    }
  });
  useEffect(() => {
    t24.set(p4), n2.set(!!f8);
  }, [f8, p4]);
}, "P");

// ../shared/dist/hooks/useTransfer/index.js
var $t = /* @__PURE__ */ __name(({
  refId: q2,
  onComplete: O3,
  widgetVersion: Q,
  iframeOrigin: C10,
  preferredInputToken: V,
  walletClientOrSigner: X
}) => {
  const s7 = useRef(), I3 = useRef(false), S4 = useStore(u3), r12 = useStore(o8), t31 = useStore(a3), R5 = useStore(l7), a5 = useStore(i3), f8 = useStore(c5), $ = useStore(p2), F = useStore(g3), T2 = useStore(k), Y3 = useStore(f4), Z = useStore(b3), tt = useStore(h2), N = (S4 == null ? void 0 : S4.flexyContractAddress) ?? r8, [E2, et] = useState(null), [c11, B3, u6, l9] = [
    t31 == null ? void 0 : t31.chain_id,
    t31 == null ? void 0 : t31.address,
    f8 == null ? void 0 : f8.id,
    T2 == null ? void 0 : T2.address
  ], {
    signTypedData: at,
    switchNetwork: G2,
    publicClient: M,
    walletClient: x4,
    address: i5,
    chainId: v2
  } = b5(X);
  P(i5, Q, C10, V);
  const { trigger: nt } = x(E2, {
    method: "GET",
    revalidate: false
  }), { trigger: it } = x(
    "/bridgeToken"
  ), { trigger: st } = x("/bridgeNative"), L3 = /* @__PURE__ */ __name(async () => {
    async function D4(d5) {
      (Q || window.location.pathname.includes("iframe")) && (s7.current = v2), await G2({ id: d5 }).catch(async (w3) => {
        const { code: h5, message: y } = w3, m5 = "wallet_addEthereumChain";
        if (h5 === 4902 || y.includes(m5)) {
          const P3 = U.find((p4) => p4.id === c11);
          P3 && await x4.addChain({ chain: P3 }).catch(() => {
            f4.set(false), b3.set(true);
          });
        }
      }).finally(() => {
        I3.current = true;
      });
    }
    __name(D4, "D");
    try {
      f4.set(true);
      let d5, w3, h5, y, m5;
      const W2 = "Invalid inputs, please reload and try again";
      if (!c11 || !B3 || !u6 || !l9 || !i5 || !E2 || !t31 || !a5)
        throw new Error(W2);
      if (v2 !== c11) {
        D4(c11);
        return;
      }
      const p4 = U.find((e44) => e44.id === v2), j2 = a5.fromTokenApproveAmount;
      if (!p4)
        throw new Error("Unsupported Chain");
      const rt = {
        approve: async () => {
          const e44 = t31.name.toLowerCase() === "usdt" && t31.chain_id === 1, { request: o12 } = await M.simulateContract({
            abi: e44 ? e36 : e35,
            functionName: "approve",
            account: i5,
            address: B3,
            chain: p4,
            args: [N, BigInt(j2)]
          });
          y = await x4.writeContract(o12);
        },
        permit: async () => {
          const { domain: e44, message: o12, types: k3, primaryType: ot } = await nt(), ct = await at({
            domain: e44,
            types: k3,
            primaryType: ot,
            account: i5,
            message: {
              ...o12,
              value: String(o12.value)
            }
          });
          d5 = o12.deadline, w3 = o12.value, h5 = ct;
        },
        native: async () => {
          const { nativeTokenPrice: e44 } = t31;
          if (e44 == null)
            throw new Error("Invalid Source Token");
          const { request: o12 } = await M.simulateContract({
            abi: t26,
            functionName: "bridgeNative",
            account: i5,
            address: N,
            chain: p4,
            value: BigInt(
              parseUnits(
                String(r12 / e44),
                t31.decimals
              )
            ),
            args: [
              u6,
              l9,
              a5.minAmountOut,
              a5.deadline
            ]
          }), k3 = await M.estimateContractGas({
            address: N,
            abi: t26,
            functionName: "bridgeNative",
            account: i5,
            value: BigInt(
              parseUnits(
                String(r12 / e44),
                t31.decimals
              )
            ),
            args: [
              u6,
              l9,
              a5.minAmountOut,
              a5.deadline
            ]
          });
          m5 = await x4.writeContract({
            ...o12,
            gas: k3 * BigInt(12) / BigInt(10)
          });
        }
      }[t31.type];
      if (await rt(), t31.type === "native" && m5) {
        const e44 = await st({
          refId: q2,
          fromChainId: c11,
          toToken: l9,
          toChainId: u6,
          iframeOrigin: C10,
          txnUSD: r12,
          txnId: m5,
          receiver: i5,
          deadline: a5.deadline,
          minAmountOut: a5.minAmountOut,
          includeDestinationGas: $ && !F,
          txnValue: 1e8
          // value in eth (calculate on frontend)
        });
        O3(e44.relayId, () => {
          setTimeout(async () => {
            s7.current && (await G2({ id: s7.current }), s7.current);
          }, 2500);
        });
      } else {
        const e44 = await it({
          fromChainId: c11,
          fromToken: B3,
          toChainId: u6,
          refId: q2,
          deadline: d5,
          iframeOrigin: C10,
          actualAmount: w3,
          signedPermitMessage: h5,
          approvalTxn: y,
          toToken: l9,
          receiver: i5,
          approvalAmount: j2,
          amount: r12,
          includeDestinationGas: $ && !F
        });
        O3(e44.relayId, () => {
          setTimeout(async () => {
            s7.current && (await G2({ id: s7.current }), s7.current);
          }, 2500);
        }), s7.current;
      }
      r6();
    } catch (d5) {
      console.log(d5), f4.set(false), b3.set(true);
    }
  }, "L");
  return useEffect(() => {
    if (r12 && t31 && a5) {
      const D4 = `/getPermitMessage
        ?chainId=${t31.chain_id}
        &token=${t31.address}
        &amount=${r12}
        &walletAddress=${i5}`;
      et(D4.replace(/\s/g, ""));
    }
  }, [i5, r12, t31, a5]), useEffect(() => {
    h2.set(true), b3.set(false);
  }, [r12, t31, f8]), useEffect(() => {
    h2.set(R5);
  }, [R5]), useEffect(() => {
    I3.current && (I3.current = false, L3());
  }, [v2]), {
    permitQuery: E2,
    failed: Z,
    setFailed: b3.set,
    type: t31 == null ? void 0 : t31.type,
    processing: Y3,
    disabled: tt || (a5 == null ? void 0 : a5.status) === 0,
    signAndSubmit: () => L3()
  };
}, "$t");

// ../shared/dist/components/transfer/transfer-submit/index.js
var O = e42__default.memo(
  (m5) => {
    const {
      failed: o12,
      setFailed: a5,
      processing: n7,
      signAndSubmit: e44,
      disabled: p4,
      permitQuery: l9,
      type: r12
    } = $t(m5);
    return o12 ? /* @__PURE__ */ e42__default.createElement("div", { className: "h-[2.85rem] grid place-items-center pt-1" }, /* @__PURE__ */ e42__default.createElement("p", { className: "flex flex-col items-center text-danger text-sm opacity-80 text-center font-normal" }, "Oops! Request failed ", /* @__PURE__ */ e42__default.createElement("br", null), /* @__PURE__ */ e42__default.createElement(
      u2,
      {
        variant: "ghost",
        className: "cursor-pointer",
        onClick: () => {
          a5(false), e44();
        }
      },
      /* @__PURE__ */ e42__default.createElement("span", { className: "underline decoration-solid text-gray-100 dark:text-gray-90 font-normal" }, "try again")
    ))) : /* @__PURE__ */ e42__default.createElement(
      u2,
      {
        fullwidth: true,
        onClick: e44,
        loading: n7,
        disabled: p4 || !l9,
        className: "transfer-submit-button"
      },
      "Sign",
      " ",
      r12 === "approve" ? "Approval" : r12 === "permit" ? "Permit" : null,
      " ",
      "& Submit"
    );
  }
);
var B = /* @__PURE__ */ __name(({
  children: o12,
  open: l9,
  onOpenChange: m5,
  closeOnBlur: i5,
  className: n7,
  wrapperClassname: s7
}) => /* @__PURE__ */ e42__default.createElement(r9.Root, { modal: true, open: l9, onOpenChange: (t31) => m5(t31) }, /* @__PURE__ */ e42__default.createElement(r9.Portal, null, /* @__PURE__ */ e42__default.createElement("div", { className: "flexy" }, /* @__PURE__ */ e42__default.createElement(r9.Overlay, { className: "fixed inset-0 bg-[#131313f3] dark:bg-[#131313f8] w-screen h-screen z-[10000]" })), /* @__PURE__ */ e42__default.createElement("div", { className: "flexy" }, /* @__PURE__ */ e42__default.createElement(
  r9.Content,
  {
    onPointerDownOutside: (t31) => !i5 && t31.preventDefault(),
    className: "flexy-portal-content fixed inset-0 z-[10000] flex justify-center w-full overflow-y-auto max-h-[100svh] scrollbar-hide py-10"
  },
  /* @__PURE__ */ e42__default.createElement(
    "div",
    {
      className: c(
        "w-full h-full flex flex-col items-center",
        s7
      )
    },
    /* @__PURE__ */ e42__default.createElement(
      "div",
      {
        className: c(
          "bg-white dark:bg-gray-300 p-6 border border-solid border-gray-90 dark:border-gray-300 outline-none rounded-22 w-[29rem] max-sm:w-full relative",
          n7
        )
      },
      o12,
      /* @__PURE__ */ e42__default.createElement(r9.Close, { asChild: true }, /* @__PURE__ */ e42__default.createElement(
        u2,
        {
          variant: "secondary",
          className: "absolute top-0 -right-16 outline-none cursor-pointer hover:opacity-60 transition-all px-0 aspect-square h-[2.5rem] max-sm:-top-16 max-sm:right-0 max-sm:left-0 max-sm:m-auto overflow-hidden"
        },
        /* @__PURE__ */ e42__default.createElement("div", { className: "w-full h-full bg-gray-90 dark:bg-gray-200 hover:bg-gray-90 hover:dark:bg-gray-300 grid place-items-center" }, /* @__PURE__ */ e42__default.createElement(
          ps,
          {
            svg: "cancel",
            className: "w-4 h-4 text-gray-400 dark:text-white"
          }
        ))
      ))
    )
  )
)))), "B");
var s5 = /* @__PURE__ */ __name(({ children: o12, portalId: r12 }) => {
  const [e44] = useState(() => {
    const t31 = document.createElement("div");
    return t31.classList.add(r12), t31.style.zIndex = "10000", t31;
  });
  return useEffect(() => (document.body.appendChild(e44), () => {
    document.body.removeChild(e44);
  }), [e44]), d4.createPortal(o12, e44);
}, "s");
var s6 = /* @__PURE__ */ __name(({
  icon: t31,
  title: c11,
  body: l9,
  footer: a5
}) => /* @__PURE__ */ e42__default.createElement("div", { className: "w-ful flex flex-col gap-8 justify-center items-center px-8 py-8" }, /* @__PURE__ */ e42__default.createElement("div", { className: "flex flex-col justify-center items-center gap-2" }, t31, /* @__PURE__ */ e42__default.createElement("h2", { className: "text-xl text-center font-semibold" }, c11), /* @__PURE__ */ e42__default.createElement("p", { className: " text-base text-gray-100 text-center justify-center items-center font-light" }, l9)), a5), "s");
var r10 = /* @__PURE__ */ __name(({ token: e44, hideChain: t31 }) => /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center gap-[0.2rem]" }, /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center gap-2 max-sm:gap-[0.3rem] rounded-30 bg-white dark:bg-gray-300 p-[0.31rem] px-[0.35rem] pr-4 max-sm:pr-[0.85rem]" }, /* @__PURE__ */ e42__default.createElement(
  "img",
  {
    src: e44.logo_url,
    alt: e44.name,
    width: 25,
    height: 25,
    className: "w-[1.56rem] h-[1.56rem]"
  }
), /* @__PURE__ */ e42__default.createElement("p", { className: "text-gray-500 dark:text-white mt-[0.05rem] max-sm:text-sm max-sm:font-medium" }, e44.name)), e44.chainAttributes && !t31 && /* @__PURE__ */ e42__default.createElement("span", { className: "grid place-items-center w-[2.1875rem] h-[2.1875rem] bg-white dark:bg-gray-300 rounded-full" }, /* @__PURE__ */ e42__default.createElement(
  "img",
  {
    src: e44.chainAttributes.logo_url,
    alt: e44.chainAttributes.name,
    width: 25,
    height: 25,
    className: "w-[1.56rem] h-[1.56rem]"
  }
))), "r");
var O2 = /* @__PURE__ */ __name(() => {
  const e44 = useStore(a3), i5 = useStore(o8), u6 = useStore(m), d5 = useStore(f4), t31 = useStore(u3), f8 = /* @__PURE__ */ __name((r12) => {
    const a5 = i5 !== 0 ? r12.slice(1) : r12;
    if (!/**hasTrailingDecimal
    ? isNaN(Number(bareValue.split('.')[0]))
    : */
    isNaN(Number(a5))) {
      let s7 = (t31 == null ? void 0 : t31.limitUSD) ?? 0;
      const p4 = Math.floor((e44 == null ? void 0 : e44.usd) ?? 0);
      p4 && (s7 = Math.min(p4, (t31 == null ? void 0 : t31.limitUSD) ?? 0));
      const b8 = Number(a5), c11 = Math.min(b8, s7);
      o8.set(
        /**hasTrailingDecimal ? Number(min) : */
        c11
      ), m.set(
        /**hasTrailingDecimal ? `${min}${min === max ? '' : '.'}` : */
        String(
          c11
        )
      );
    }
  }, "f");
  return useEffect(() => {
    o8.set(0);
  }, [e44]), /* @__PURE__ */ e42__default.createElement(
    g,
    {
      className: "transfer-input",
      placeholder: "$0.00",
      label: "You Send",
      secondaryLabel: `Max Allowed: ${t31 != null && t31.limitUSD ? `$${t31.limitUSD}` : "-"}`,
      value: i5 !== 0 ? `$${u6}` : "",
      disabled: d5,
      onChange: (r12) => f8(r12.target.value),
      renderBottomRight: (() => {
        if (e44) {
          const r12 = d2(
            e44.balance,
            e44.decimals,
            e44.usd
          );
          return /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center gap-[0.63rem]" }, /* @__PURE__ */ e42__default.createElement("p", { className: " text-xs" }, "~", c2(i5 / r12, 4)), /* @__PURE__ */ e42__default.createElement(r10, { token: e44 }));
        }
      })()
    }
  );
}, "O");
var S = /* @__PURE__ */ __name(({ title: m5, tip: r12 }) => /* @__PURE__ */ e42__default.createElement("p", { className: "flex items-center gap-[0.15rem] text-gray-100 max-sm:text-sm" }, m5, /* @__PURE__ */ e42__default.createElement(w, { usePortal: false, content: r12 }, /* @__PURE__ */ e42__default.createElement(
  ps,
  {
    svg: "info-circle",
    className: "mt-[0.07rem] w-[0.875rem] h-[0.875rem]"
  }
))), "S");
var j = /* @__PURE__ */ __name(({
  loading: r12,
  spinnerText: m5,
  children: o12
}) => /* @__PURE__ */ e42__default.createElement(e42__default.Fragment, null, r12 ? /* @__PURE__ */ e42__default.createElement(
  c4,
  {
    className: "text-gray-100 text-xs gap-2",
    spinnerClass: "w-3 h-3",
    text: m5
  }
) : o12), "j");
var Y = /* @__PURE__ */ __name(() => {
  const k3 = useStore(o8), t31 = useStore(a3), d5 = useStore(c5), o12 = useStore(i3), q2 = useStore(T), A2 = useStore(l7), s7 = useStore(k), h5 = useStore(p2), v2 = useStore(g3), [m5, I3] = useState(""), [i5, f8, l9, u6, C10] = [
    k3,
    d5 == null ? void 0 : d5.id,
    t31 == null ? void 0 : t31.chain_id,
    s7 == null ? void 0 : s7.address,
    t31 != null && t31.address.includes("0x") ? t31.address : "0x0000000000000000000000000000000000000000"
  ], { isLoading: g7, isValidating: F } = d(m5, {
    revalidateOnFocus: false,
    onSuccess(n7) {
      if (i3.set(n7), t31 && d5) {
        const {
          toNativePriceUSD: G2,
          fromNativePriceUSD: P3,
          toTokenPriceUSD: L3,
          fromTokenPriceUSD: N,
          toGasCostUSD: p4,
          fromGasCostUSD: T2,
          gasbotFeeUSD: x4
        } = n7, Q = `1 ${t31 == null ? void 0 : t31.name} = 
        ${parseFloat((N / L3).toFixed(4))}
        ${s7 == null ? void 0 : s7.symbol}`;
        T.set({
          rate: Q,
          fromGasCostToken: c2(T2 / P3, 6),
          fromGasCostUsd: c2(T2),
          toGasCostUsd: c2(p4),
          toGasCostToken: c2(p4 / G2, 6),
          flexyChargeToken: c2(x4 / G2, 4),
          flexyChargeUsd: c2(x4)
        });
      } else
        T.set(void 0);
    }
  }), c11 = useMemo(
    () => E.debounce((n7) => {
      mutate(n7).then(() => {
        I3(n7);
      });
    }, 500),
    []
  );
  return useEffect(() => {
    l7.set(i5 > 0 && (g7 || F));
  }, [g7, F, i5]), useEffect(() => {
    i5 > 0 || mutate(m5, void 0, { revalidate: false }).then(() => {
      T.set(void 0), i3.set(void 0), c11.cancel();
    });
  }, [c11, i5, m5]), useEffect(() => {
    if (c11.cancel(), l9 && C10 && f8 && u6 && i5 > 0) {
      const n7 = `/getSwapData
      ?fromChainId=${l9}
      &toChainId=${f8}
      &fromAmount=${i5}
      &fromToken=${C10}
      &toToken=${u6}
      &includeDestinationGas=${h5 && !v2}`;
      c11(n7.replace(/\s/g, ""));
    }
  }, [
    u6,
    l9,
    C10,
    f8,
    i5,
    c11,
    h5,
    v2
  ]), {
    fees: q2,
    sourceToken: t31,
    status: o12 == null ? void 0 : o12.status,
    destinationToken: s7,
    amountToReceive: o12 == null ? void 0 : o12.toAmountToken.toFixed(4),
    amountToReceiveUsd: o12 == null ? void 0 : o12.toAmountUSD.toFixed(2),
    toChainLiquidity: o12 == null ? void 0 : o12.toChainLiquidity.toFixed(4),
    totalFeeUsd: o12 == null ? void 0 : o12.totalFeeUSD.toString(),
    arrivalTime: o12 ? "~15s" : void 0,
    destinationChain: d5,
    loading: A2
  };
}, "Y");
var n6 = /* @__PURE__ */ __name(({
  sourceToken: l9,
  fees: t31,
  destinationChain: a5,
  totalFeeUsd: r12
}) => {
  var m5;
  return /* @__PURE__ */ e42__default.createElement("div", { className: "grid grid-cols-1 gap-2 w-[13.5rem]" }, (l9 == null ? void 0 : l9.type) !== "native" && /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center justify-between text-gray-100" }, /* @__PURE__ */ e42__default.createElement("p", null, "Gas cost on ", (m5 = l9 == null ? void 0 : l9.chainAttributes) == null ? void 0 : m5.name, ":"), /* @__PURE__ */ e42__default.createElement("p", null, "$", t31 == null ? void 0 : t31.fromGasCostUsd)), /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center justify-between text-gray-100" }, /* @__PURE__ */ e42__default.createElement("p", null, "Gas cost on ", a5 == null ? void 0 : a5.name, ":"), /* @__PURE__ */ e42__default.createElement("p", null, "$", t31 == null ? void 0 : t31.toGasCostUsd)), /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center justify-between text-gray-100" }, /* @__PURE__ */ e42__default.createElement("p", null, "Flexy Fee:"), /* @__PURE__ */ e42__default.createElement("p", null, /* @__PURE__ */ e42__default.createElement("span", null, "$", t31 == null ? void 0 : t31.flexyChargeUsd))), /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center justify-between mt-2" }, /* @__PURE__ */ e42__default.createElement("p", null, "Total:"), /* @__PURE__ */ e42__default.createElement("p", null, "$", r12)));
}, "n");

// ../shared/dist/components/transfer/transfer-summary/index.js
var P2 = /* @__PURE__ */ __name(() => {
  const i5 = useStore(c7), {
    totalFeeUsd: t31,
    destinationToken: c11,
    sourceToken: o12,
    loading: r12,
    fees: a5,
    status: p4,
    amountToReceiveUsd: m5,
    toChainLiquidity: n7,
    destinationChain: u6
  } = Y();
  return p4 === 0 && !r12 ? /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center justify-center text-center text-sm font-normal leading-relaxed opacity-100 text-warning brightness-[0.6] dark:brightness-90 dark:opacity-75 my-4" }, Number(m5) < 0.5 ? /* @__PURE__ */ e42__default.createElement("p", null, "Transaction cannot be completed ", /* @__PURE__ */ e42__default.createElement("br", null), " due to the small output amount ", /* @__PURE__ */ e42__default.createElement("b", { className: "font-medium" }, "~$", m5)) : /* @__PURE__ */ e42__default.createElement("p", null, "Transaction cannot be completed due to low ", /* @__PURE__ */ e42__default.createElement("br", null), " liquidity", " ", /* @__PURE__ */ e42__default.createElement("b", { className: "font-medium" }, "~$", n7 == null ? void 0 : n7.split(".")[0]), " ", "on destination chain. Try again later")) : /* @__PURE__ */ e42__default.createElement(
    "div",
    {
      className: c(
        "transfer-summary relative grid grid-cols-1 gap-[1.37rem] my-4",
        {
          "pointer-events-none opacity-50": i5
        }
      )
    },
    /* @__PURE__ */ e42__default.createElement("div", { className: "grid grid-cols-1 gap-4" }, /* @__PURE__ */ e42__default.createElement("p", { className: "text-sm font-semibold" }, "Summary"), /* @__PURE__ */ e42__default.createElement("ul", { className: "grid grid-cols-1 gap-[0.69rem] text-sm font-normal" }, /* @__PURE__ */ e42__default.createElement("li", { className: "flex items-center justify-between" }, /* @__PURE__ */ e42__default.createElement(
      S,
      {
        title: "Flexy Charge",
        tip: t31 ? /* @__PURE__ */ e42__default.createElement(
          n6,
          {
            totalFeeUsd: t31,
            destinationToken: c11,
            sourceToken: o12,
            destinationChain: u6,
            fees: a5
          }
        ) : "Transaction fee summary"
      }
    ), /* @__PURE__ */ e42__default.createElement(j, { loading: r12, spinnerText: "calculating..." }, /* @__PURE__ */ e42__default.createElement("p", { className: "max-sm:text-sm" }, t31 ? /* @__PURE__ */ e42__default.createElement("span", null, t31, " USD") : "-"))), /* @__PURE__ */ e42__default.createElement("li", { className: "flex items-center justify-between" }, /* @__PURE__ */ e42__default.createElement(S, { title: "Price rate", tip: "Price conversion rate" }), /* @__PURE__ */ e42__default.createElement(j, { loading: r12, spinnerText: "calculating..." }, /* @__PURE__ */ e42__default.createElement("p", { className: "max-sm:text-sm" }, (a5 == null ? void 0 : a5.rate) ?? "-")))))
  );
}, "P");
var ae = /* @__PURE__ */ __name(({ id: s7 }) => {
  var c11, p4;
  const [l9, m5] = useState(), [i5, h5] = useState(false), [a5, b8] = useState(false), { data: e44, isLoading: y, error: E2 } = d(
    s7 ? `/status?bridgeId=${s7}` : null,
    {
      errorRetryCount: 2,
      errorRetryInterval: 4e3,
      revalidateOnFocus: false,
      refreshInterval: i5 ? void 0 : 1e3
    }
  );
  return useEffect(() => {
    const r12 = setTimeout(() => {
      m5(void 0);
    }, 2e3);
    return () => {
      clearTimeout(r12);
    };
  }, [l9]), useEffect(() => {
    const r12 = e44 == null ? void 0 : e44.status.toLowerCase(), v2 = r12 == null ? void 0 : r12.includes("completed"), N = Number(e44 == null ? void 0 : e44.step) === 99;
    v2 && (h5(true), o8.set(0), f4.set(false), l7.set(false), i3.set(void 0), a3.set(void 0), c5.set(void 0)), N && b8(true);
  }, [e44 == null ? void 0 : e44.status, e44 == null ? void 0 : e44.step]), y ? /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center h-full justify-center min-h-[15rem] gap-6 pb-2" }, /* @__PURE__ */ e42__default.createElement(
    c4,
    {
      className: "text-sm",
      spinnerClass: "w-4 h-4",
      text: "fetching transaction..."
    }
  )) : E2 ? /* @__PURE__ */ e42__default.createElement(
    s6,
    {
      title: "Invalid Id",
      body: "The id provided in the url does not belong to any flexy transaction, please refresh or check the url and try again.",
      icon: /* @__PURE__ */ e42__default.createElement(ps, { svg: "error-circle", className: "w-16 h-16  mb-2 text-danger" })
    }
  ) : /* @__PURE__ */ e42__default.createElement("div", { className: "flex flex-col items-center justify-between min-h-[15rem] gap-6 pb-2" }, /* @__PURE__ */ e42__default.createElement("div", { className: "mt-4 sm:mt-6 flex flex-col items-center" }, /* @__PURE__ */ e42__default.createElement(
    ps,
    {
      svg: "bolt",
      className: "h-10 w-10 sm:h-12 sm:w-12 mb-5 text-primary"
    }
  ), /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center gap-1 mb-2" }, /* @__PURE__ */ e42__default.createElement("h4", { className: "text-xl sm:text-2xl font-semibold " }, "TR #", s7), /* @__PURE__ */ e42__default.createElement(
    w,
    {
      open: l9,
      usePortal: false,
      content: /* @__PURE__ */ e42__default.createElement("div", { className: "w-full text-center" }, l9 ? "Copied!" : "Copy Trxn Url")
    },
    /* @__PURE__ */ e42__default.createElement(
      u2,
      {
        variant: "ghost",
        onClick: async () => {
          await s(`https://www.flexy.tech/bridge/${s7}`), m5(true);
        }
      },
      /* @__PURE__ */ e42__default.createElement(ps, { svg: "copy", className: "w-6 h-6 text-gray-100" })
    )
  )), a5 ? /* @__PURE__ */ e42__default.createElement("div", { className: "flex flex-col justify-center items-center space-y-2" }, /* @__PURE__ */ e42__default.createElement("span", { className: "leading-0 text-sm font-medium grid place-items-center px-4 py-1 bg-danger text-white rounded-60" }, "Failed"), /* @__PURE__ */ e42__default.createElement("span", { className: "text-gray-100 text-sm font-medium" }, e44 == null ? void 0 : e44.status)) : i5 ? /* @__PURE__ */ e42__default.createElement("span", { className: "leading-0 text-sm font-medium grid place-items-center px-4 py-1 bg-success text-white rounded-60" }, "Completed") : /* @__PURE__ */ e42__default.createElement(c4, { spinnerClass: "w-4 h-4", text: e44 == null ? void 0 : e44.status })), /* @__PURE__ */ e42__default.createElement("ul", { className: "grid grid-cols-1 gap-[0.69rem] text-sm font-normal w-full" }, /* @__PURE__ */ e42__default.createElement("li", { className: "flex items-center justify-between" }, /* @__PURE__ */ e42__default.createElement(
    S,
    {
      title: "Inbound Trxn",
      tip: "Transction from your wallet to Flexy"
    }
  ), /* @__PURE__ */ e42__default.createElement(
    j,
    {
      loading: !(e44 != null && e44.inboundTxnURL.includes("0x")),
      spinnerText: "fetching..."
    },
    /* @__PURE__ */ e42__default.createElement(
      "a",
      {
        href: e44 == null ? void 0 : e44.inboundTxnURL,
        target: "_blank",
        rel: "noreferrer noopener",
        className: "font-normal hover:text-primary transition-all flex items-center gap-2"
      },
      e44 ? a(
        (c11 = e44 == null ? void 0 : e44.inboundTxnURL) == null ? void 0 : c11.split("/")[e44.inboundTxnURL.split("/").length - 1]
      ) : "-",
      /* @__PURE__ */ e42__default.createElement(ps, { svg: "link-out", className: " w-3 h-3" })
    )
  )), /* @__PURE__ */ e42__default.createElement("li", { className: "flex items-center justify-between" }, /* @__PURE__ */ e42__default.createElement(
    S,
    {
      title: "Outbound Trxn",
      tip: "Transction from Flexy to your wallet"
    }
  ), a5 ? /* @__PURE__ */ e42__default.createElement("span", { className: "font-normal text-gray-100" }, "Unexecuted") : /* @__PURE__ */ e42__default.createElement(
    j,
    {
      loading: !(e44 != null && e44.outboundTxnURL.includes("0x")),
      spinnerText: "fetching..."
    },
    /* @__PURE__ */ e42__default.createElement(
      "a",
      {
        href: e44 == null ? void 0 : e44.outboundTxnURL,
        target: "_blank",
        rel: "noreferrer noopener",
        className: "font-normal hover:text-primary transition-all flex items-center gap-2"
      },
      e44 ? a(
        (p4 = e44 == null ? void 0 : e44.outboundTxnURL) == null ? void 0 : p4.split("/")[e44.outboundTxnURL.split("/").length - 1]
      ) : "-",
      /* @__PURE__ */ e42__default.createElement(ps, { svg: "link-out", className: " w-3 h-3" })
    )
  ))));
}, "ae");
var b7 = /* @__PURE__ */ __name((n7, o12) => {
  const r12 = C9(n7);
  if (!o12)
    return r12;
  const c11 = C9(o12);
  return {
    left: r12.left - c11.left,
    top: r12.top - c11.top,
    right: r12.right - c11.left,
    bottom: r12.bottom - c11.top,
    width: r12.width,
    height: r12.height
  };
}, "b");
var C9 = /* @__PURE__ */ __name((n7) => {
  const o12 = n7.getBoundingClientRect();
  let r12 = 0, c11 = 0, i5 = n7.parentElement;
  for (; i5; )
    r12 += i5.scrollLeft, c11 += i5.scrollTop, i5 = i5.parentElement;
  const l9 = o12.left + r12, h5 = o12.top + c11;
  return {
    left: l9,
    top: h5,
    right: l9 + o12.width,
    bottom: h5 + o12.height,
    width: o12.width,
    height: o12.height
  };
}, "C");
function H(n7, o12) {
  if (!n7)
    throw new Error(o12);
}
__name(H, "H");
var G = /* @__PURE__ */ __name(({
  axis: n7 = "x",
  initialPages: o12 = []
} = {}) => {
  const r12 = n7 === "x" ? "width" : "height", c11 = n7 === "x" ? "scrollWidth" : "scrollHeight", i5 = n7 === "x" ? "clientWidth" : "clientHeight", l9 = n7 === "x" ? "left" : "top", h5 = n7 === "x" ? "right" : "bottom", T2 = n7 === "x" ? "scrollLeft" : "scrollTop", [e44, A2] = useState(null), [{ pages: a5, activePageIndex: x4 }, M] = useState({
    pages: o12,
    activePageIndex: 0
  }), p4 = useCallback(
    (t31) => {
      if (!e44)
        return;
      if (Math.floor(e44[c11] - e44[T2]) <= e44[i5]) {
        M({ pages: t31, activePageIndex: t31.length - 1 });
        return;
      }
      const d5 = Array.from(e44.children), u6 = e44.getBoundingClientRect(), s7 = t31.map((v2) => {
        const w3 = v2[0], S4 = d5[w3];
        H(S4 instanceof HTMLElement, "Expected HTMLElement");
        const z2 = S4.getBoundingClientRect()[l9] - u6[l9];
        return Math.abs(z2);
      }), m5 = Math.min(...s7), E2 = s7.indexOf(m5);
      M({ pages: t31, activePageIndex: E2 });
    },
    [e44, i5, l9, c11, T2]
  ), f8 = useCallback(() => {
    if (!e44)
      return;
    const t31 = Array.from(e44.children), g7 = e44.getBoundingClientRect();
    let d5;
    const u6 = t31.reduce((s7, m5, E2) => {
      H(m5 instanceof HTMLElement, "Expected HTMLElement");
      const v2 = s7[s7.length - 1], w3 = b7(m5, m5.parentElement);
      return !v2 || w3[h5] - d5 > Math.ceil(g7[r12]) ? (s7.push([E2]), d5 = w3[l9]) : v2.push(E2), s7;
    }, []);
    p4(u6);
  }, [p4, e44, r12, h5, l9]);
  useEffect(() => {
    f8();
  }, [f8]), useEffect(() => {
    const t31 = /* @__PURE__ */ __name(() => {
      f8();
    }, "t");
    return window.addEventListener("resize", t31), window.addEventListener("orientationchange", t31), () => {
      window.removeEventListener("resize", t31), window.removeEventListener("orientationchange", t31);
    };
  }, [f8]), useEffect(() => {
    if (!e44)
      return;
    const t31 = /* @__PURE__ */ __name(() => {
      p4(a5);
    }, "t");
    return e44.addEventListener("scroll", t31), () => {
      e44.removeEventListener("scroll", t31);
    };
  }, [p4, a5, e44]);
  const P3 = /* @__PURE__ */ __name((t31) => {
    if (!e44)
      return;
    const g7 = a5[t31];
    if (!g7)
      return;
    const d5 = Array.from(e44.children), u6 = g7[0], s7 = d5[u6];
    s7 instanceof HTMLElement && e44.scrollTo({
      behavior: "smooth",
      [l9]: b7(s7, s7.parentElement)[l9]
    });
  }, "P"), B3 = /* @__PURE__ */ __name(() => {
    P3(x4 - 1);
  }, "B"), O3 = /* @__PURE__ */ __name(() => {
    P3(x4 + 1);
  }, "O"), y = useMemo(
    () => new Set(a5.map((t31) => t31[0])),
    [a5]
  );
  return {
    prev: B3,
    next: O3,
    goTo: P3,
    refresh: f8,
    pages: a5,
    activePageIndex: x4,
    snapPointIndexes: y,
    scrollRef: A2
  };
}, "G");
var ce = /* @__PURE__ */ __name(() => {
  const l9 = useStore(t24), y = useStore(n2), c11 = useStore(c5), a5 = useStore(a3), n7 = useStore(e33), b8 = useStore(f4), v2 = useStore(c7), i5 = useRef(null), { scrollRef: E2, pages: N, activePageIndex: m5, prev: w3, next: k3, snapPointIndexes: _2 } = G();
  return /* @__PURE__ */ e42__default.createElement("div", { className: "grid grid-cols-1 gap-2 no-scrollbar" }, /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center justify-between" }, /* @__PURE__ */ e42__default.createElement("p", { className: "text-sm font-semibold" }, "Select Asset"), !l9 && /* @__PURE__ */ e42__default.createElement("div", { className: "grid grid-cols-2 gap-6" }, /* @__PURE__ */ e42__default.createElement(
    u2,
    {
      variant: "ghost",
      className: "text-gray-500 dark:text-white !bg-transparent hover:opacity-70 transition-all",
      onClick: () => w3(),
      disabled: n7.length < 3 || m5 <= 0
    },
    /* @__PURE__ */ e42__default.createElement(ps, { svg: "arrow-left", className: "w-6 h-6" })
  ), /* @__PURE__ */ e42__default.createElement(
    u2,
    {
      variant: "ghost",
      className: "text-gray-500 dark:text-white !bg-transparent hover:opacity-70 transition-all",
      onClick: () => k3(),
      disabled: n7.length < 3 || m5 === N.length - 1
    },
    /* @__PURE__ */ e42__default.createElement(ps, { svg: "arrow-right", className: "w-6 h-6" })
  ))), /* @__PURE__ */ e42__default.createElement("div", { className: "min-h-[4rem] w-full overflow-x-hidden scrollbar-hide" }, v2 ? /* @__PURE__ */ e42__default.createElement("span", { className: "opacity-100 text-warning brightness-[0.6] dark:brightness-90 dark:opacity-75 h-full flex items-center justify-center gap-1 text-sm" }, /* @__PURE__ */ e42__default.createElement(ps, { svg: "info-circle", className: "w-5 h-5 mt-[0.05rem]" }), "Connect Wallet To Scan Assets") : l9 ? /* @__PURE__ */ e42__default.createElement(c4, { text: "Scannning wallet...", className: "text-sm" }) : y ? /* @__PURE__ */ e42__default.createElement("span", { className: "text-danger opacity-70 h-full flex items-center justify-center gap-1 text-sm" }, /* @__PURE__ */ e42__default.createElement(ps, { svg: "info-circle", className: "w-4 h-4 mt-[0.15rem]" }), "failed to fetch tokens") : !l9 && !n7.length ? /* @__PURE__ */ e42__default.createElement("span", { className: "text-gray-100 opacity-70 h-full flex items-center justify-center gap-1 text-sm" }, /* @__PURE__ */ e42__default.createElement(ps, { svg: "info-circle", className: "w-4 h-4 mt-[0.15rem]" }), "you do not have any assets") : /* @__PURE__ */ e42__default.createElement(
    "div",
    {
      role: "slider",
      ref: E2,
      className: c(
        "relative overflow-auto flex items-center gap-1.5 max-sm:gap-[0.3rem] snap-mandatory snap-x scrollbar-hide",
        {
          "pointer-events-none opacity-50": b8
        }
      )
    },
    n7.map((t31, d5) => {
      var p4, g7, h5;
      return /* @__PURE__ */ e42__default.createElement(
        u2,
        {
          key: d5,
          variant: "ghost",
          className: c(
            "token-card h-[6.3rem] w-40 shrink-0 !rounded-15 bg-gray-75 dark:bg-gray-200  flex-col justify-between items-start p-[0.7rem] gap-2 border border-solid border-gray-75 dark:border-gray-200 hover:opacity-80 relative transition-all",
            {
              "snap-start": _2.has(d5),
              "border-gray-90 dark:border-gray-100 hover:opacity-100": (a5 == null ? void 0 : a5.address) === t31.address && a5.chain_id === t31.chain_id
            }
          ),
          onClick: () => {
            a3.set(t31);
            const A2 = c11 == null ? void 0 : c11.id.toString();
            t31.address === A2 && c5.set(void 0);
          },
          "data-selected": (a5 == null ? void 0 : a5.address) === t31.address
        },
        /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center gap-2 w-full" }, /* @__PURE__ */ e42__default.createElement(
          "img",
          {
            src: t31.logo_url,
            className: "w-6 h-6 shrink-0",
            alt: t31.name,
            width: 25,
            height: 25
          }
        ), /* @__PURE__ */ e42__default.createElement(
          "span",
          {
            className: "h-[1.0625rem] pl-[0.2rem] pr-[0.38rem] rounded-30 flex items-center text-[0.625rem] font-semibold gap-[0.1rem] shrink-0",
            style: {
              color: (p4 = t31.chainAttributes) == null ? void 0 : p4.text_color,
              backgroundColor: (g7 = t31.chainAttributes) == null ? void 0 : g7.background_color
            }
          },
          t31.chainAttributes && /* @__PURE__ */ e42__default.createElement(
            "img",
            {
              src: t31.chainAttributes.logo_url,
              alt: t31.chainAttributes.name,
              width: 15,
              height: 15
            }
          ),
          (h5 = t31.chainAttributes) == null ? void 0 : h5.name
        ), t31.type === "permit" && /* @__PURE__ */ e42__default.createElement("span", { className: "ml-auto shrink-0" }, /* @__PURE__ */ e42__default.createElement(
          w,
          {
            underline: false,
            customParent: i5,
            content: /* @__PURE__ */ e42__default.createElement("div", { className: "leading-snug text-gray-100 text-center" }, "Gasless Transaction")
          },
          /* @__PURE__ */ e42__default.createElement(ps, { svg: "thunder", className: "w-5 h-5 text-primary" })
        ))),
        /* @__PURE__ */ e42__default.createElement("div", { className: "flex flex-col items-start gap-[0.1rem] w-full" }, /* @__PURE__ */ e42__default.createElement("p", { className: "text-gray-500 dark:text-white text-base font-medium" }, t31.name), /* @__PURE__ */ e42__default.createElement("p", { className: "text-sm text-gray-100 font-medium leading-none" }, "$", t31.usd)),
        (a5 == null ? void 0 : a5.address) === t31.address && a5.chain_id === t31.chain_id && /* @__PURE__ */ e42__default.createElement("div", { className: "text-gray-200 dark:text-gray-75 absolute right-2 bottom-2" }, /* @__PURE__ */ e42__default.createElement(ps, { svg: "check-circle", className: "w-6 h-6" }))
      );
    }),
    /* @__PURE__ */ e42__default.createElement("span", { ref: i5 })
  )));
}, "ce");
var ht = /* @__PURE__ */ __name((u6, S4) => {
  var N;
  const [U2, W2] = useState(false), q2 = useStore(i3), p4 = useStore(s4), o12 = useStore(c5), t31 = useStore(a3), x4 = useStore(v), v2 = useStore(f4), C10 = useStore(b3), E2 = useStore(c7), f8 = useStore(k), J2 = useStore(p2), M = useStore(g3), j2 = useStore(l7), L3 = useStore(o8), d5 = useStore(u3), { chainLimit: h5, tokenLimit: m5 } = useMemo(() => ({ chainLimit: typeof u6 == "number" ? [u6] : u6, tokenLimit: typeof S4 == "string" ? [S4] : S4 }), [u6, S4]), O3 = (h5 == null ? void 0 : h5.length) === 1, y = (m5 == null ? void 0 : m5.length) === 1, z2 = m5 ? `&limitOutputTokens=${JSON.stringify(m5)}` : "", F = o12 != null && o12.id ? `/getOutputTokens?chainId=${o12.id}${z2}` : null, { data: r12 } = d(F, { version: "v3" }), l9 = useCallback(
    (e44) => p4.find((s7) => s7.id == Number(e44)),
    [p4]
  ), H2 = useMemo(() => p4.filter((s7) => {
    if (s7.id === (o12 == null ? void 0 : o12.id))
      return false;
    if (s7.nativeToken)
      return s7.nativeToken.usd >= 3;
  }).map((s7) => ({
    title: s7.name,
    value: String(s7.id),
    ...s7
  })), [o12, p4]), K = useMemo(() => (Array.isArray(u6) ? p4.filter((s7) => u6.includes(s7.id)) : p4).filter((s7) => (t31 == null ? void 0 : t31.address) !== s7.id.toString()).map((s7) => ({
    title: s7.name,
    value: String(s7.id),
    ...s7
  })), [t31 == null ? void 0 : t31.address, p4, u6]), R5 = useMemo(() => {
    const e44 = r12 == null ? void 0 : r12.tokens, n7 = [], s7 = [];
    for (const c11 of e44 ?? []) {
      const a5 = {
        title: c11.name,
        value: c11.address,
        ...c11
      };
      a5.address === (t31 == null ? void 0 : t31.address) && a5.chainId === (t31 == null ? void 0 : t31.chain_id.toString()) || (s7.push(a5), a5.sortNum < 4 && n7.push(a5));
    }
    return {
      favorites: n7,
      options: s7.sort((c11, a5) => {
        const k3 = c11.name.toLowerCase(), A2 = a5.name.toLowerCase();
        return k3 < A2 ? -1 : k3 > A2 ? 1 : 0;
      })
    };
  }, [t31 == null ? void 0 : t31.address, t31 == null ? void 0 : t31.chain_id, r12 == null ? void 0 : r12.tokens]), V = /* @__PURE__ */ __name((e44) => {
    var n7;
    (n7 = c5) == null || n7.set(l9(Number(e44))), k.set(void 0);
  }, "V"), b8 = useCallback(
    (e44) => {
      k.set(r12 == null ? void 0 : r12.tokens.find((n7) => n7.address === e44));
    },
    [r12 == null ? void 0 : r12.tokens]
  ), X = /* @__PURE__ */ __name((e44) => {
    var s7;
    const n7 = l9(Number(e44));
    (s7 = v) == null || s7.set(n7), a3.set(n7 == null ? void 0 : n7.nativeToken);
  }, "X");
  return useEffect(() => {
    !v2 && !C10 && (O3 && c5.set(l9(h5[0])), y && o12 && b8(m5[0]));
  }, [
    l9,
    O3,
    v2,
    C10,
    y,
    b8,
    h5,
    m5,
    o12
  ]), useEffect(() => {
    var a5;
    const e44 = f8 && (f8 == null ? void 0 : f8.address) === ((a5 = o12 == null ? void 0 : o12.nativeToken) == null ? void 0 : a5.address), n7 = (t31 == null ? void 0 : t31.chain_id) ?? 10, s7 = (d5 == null ? void 0 : d5.minDestinationGasUSD[n7]) ?? 1, c11 = L3 < s7;
    g3.set(e44 || c11);
  }, [
    L3,
    f8,
    t31 == null ? void 0 : t31.chain_id,
    d5 == null ? void 0 : d5.minDestinationGasUSD,
    (N = o12 == null ? void 0 : o12.nativeToken) == null ? void 0 : N.address
  ]), {
    locked: O3,
    lockedOutputToken: y,
    sourceOptions: H2,
    showOutputOptions: U2,
    setShowOutputOptions: W2,
    destinationOptions: K,
    updateSourceChain: X,
    updateDestinationChain: V,
    init: d5,
    selectedToken: t31,
    processing: v2,
    disconnected: E2,
    calculating: j2,
    destinationChain: o12,
    destinationGas: J2,
    sourceChain: x4,
    outputToken: f8,
    outputTokenOptions: R5 ?? [],
    setOutputToken: b8,
    setDestinationGas: p2.set,
    transferSummary: q2,
    disableDestinationGas: M
  };
}, "ht");
var B2 = /* @__PURE__ */ __name(({
  destinationChain: e44,
  destinationOptions: t31,
  locked: m5,
  processing: a5,
  disconnected: o12,
  updateDestinationChain: p4
}) => {
  const s7 = /* @__PURE__ */ __name(() => /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center justify-start text-left w-full h-full chain-dropdown-value" }, /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center gap-2 cursor-pointer" }, /* @__PURE__ */ e42__default.createElement(
    "div",
    {
      className: "w-[1.875rem] h-[1.875rem] max-sm:w-7 max-sm:h-7 grid place-items-center rounded-full overflow-hidden shrink-0",
      style: {
        backgroundColor: e44 == null ? void 0 : e44.background_color
      }
    },
    e44 != null && e44.logo_url ? /* @__PURE__ */ e42__default.createElement(
      "img",
      {
        alt: e44 == null ? void 0 : e44.name,
        src: e44 == null ? void 0 : e44.logo_url,
        width: 25,
        height: 25,
        className: "w-6 h-6 max-sm:w-5 max-sm:h-5"
      }
    ) : /* @__PURE__ */ e42__default.createElement(
      c4,
      {
        className: "w-5 h-5 opacity-40",
        spinnerClass: "dark:fill-none"
      }
    )
  ), /* @__PURE__ */ e42__default.createElement("span", { className: "truncate break-keep max-w-[9rem]" }, e44 == null ? void 0 : e44.name))), "s"), u6 = /* @__PURE__ */ __name((l9) => {
    var c11;
    return /* @__PURE__ */ e42__default.createElement("div", { className: "p-3 w-full flex items-center gap-3 cursor-pointer hover:bg-gray-75 dark:hover:bg-gray-500 transition-all" }, /* @__PURE__ */ e42__default.createElement(
      "span",
      {
        className: "w-8 h-8 grid place-items-center rounded-full overflow-hidden",
        style: { backgroundColor: l9.background_color }
      },
      l9.logo_url && /* @__PURE__ */ e42__default.createElement(
        "img",
        {
          alt: l9.name,
          src: l9.iconUrl ?? l9.logo_url,
          width: 25,
          height: 25,
          className: "w-6 h-6"
        }
      )
    ), /* @__PURE__ */ e42__default.createElement("div", { className: "flex flex-col items-start origin-left scale-95" }, /* @__PURE__ */ e42__default.createElement("p", null, l9.name), /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center space-x-1 text-gray-100" }, /* @__PURE__ */ e42__default.createElement(ps, { svg: "logomark", className: "h-3.5 w-3.5" }), /* @__PURE__ */ e42__default.createElement("span", { className: "text-sm uppercase" }, /* @__PURE__ */ e42__default.createElement(Fragment, null, "$", ((c11 = l9.nativeToken) == null ? void 0 : c11.usd) ?? 0, " "), "USD"))));
  }, "u");
  return /* @__PURE__ */ e42__default.createElement(
    A,
    {
      variant: "ghost",
      usePortal: false,
      hideSelectIcon: m5,
      options: t31,
      disallowChange: m5,
      renderValue: s7,
      renderOption: u6,
      disabled: a5 || o12,
      value: e44 == null ? void 0 : e44.id.toString(),
      onValueChange: p4,
      placeholder: "Select chain",
      contentClassname: "chain-dropdown-content !w-[calc(100%+6rem)] mt-1.5",
      className: "chain-dropdown h-full static"
    }
  );
}, "B");
var me = /* @__PURE__ */ __name(({
  limitDestination: u6,
  limitOutputTokens: m5
}) => {
  var w3;
  const {
    init: d5,
    locked: v2,
    processing: k3,
    outputToken: a5,
    calculating: o12,
    disconnected: D4,
    selectedToken: p4,
    destinationGas: y,
    destinationChain: t31,
    lockedOutputToken: E2,
    updateDestinationChain: G2,
    destinationOptions: U2,
    setDestinationGas: A2,
    showOutputOptions: h5,
    setShowOutputOptions: c11,
    outputTokenOptions: N,
    setOutputToken: f8,
    disableDestinationGas: n7,
    transferSummary: s7
  } = ht(u6, m5);
  return /* @__PURE__ */ e42__default.createElement(Fragment, null, /* @__PURE__ */ e42__default.createElement("div", { className: "relative flex flex-col items-center" }, /* @__PURE__ */ e42__default.createElement("div", { className: "chain-dropdown-logomark absolute w-[2.3rem] h-[2.3rem] bg-gray-75 dark:bg-gray-500 rounded-full -top-[1.27rem] grid place-items-center" }, /* @__PURE__ */ e42__default.createElement(
    ps,
    {
      svg: "bolt",
      className: "w-[1.125rem] h-[1.125rem] -mr-[0.07rem] -mb-[0.05rem]"
    }
  )), /* @__PURE__ */ e42__default.createElement("div", { className: "w-full space-y-2" }, /* @__PURE__ */ e42__default.createElement("p", { className: "text-sm font-semibold" }, "Destination"), /* @__PURE__ */ e42__default.createElement("div", { className: "rounded-30 overflow-hidden bg-gray-75 dark:bg-gray-200 output-wrapper" }, /* @__PURE__ */ e42__default.createElement("div", { className: "border-b border-solid border-white dark:border-gray-300 flex justify-between items-center py-[0.875rem] px-5 output-wrapper-section" }, /* @__PURE__ */ e42__default.createElement("div", { className: "relative pr-6 min-h-[1.875rem] flex items-center" }, /* @__PURE__ */ e42__default.createElement(
    B2,
    {
      locked: v2,
      processing: k3,
      disconnected: D4,
      destinationChain: t31,
      destinationOptions: U2,
      updateDestinationChain: G2
    }
  )), /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center space-x-1.5 shrink-0" }, /* @__PURE__ */ e42__default.createElement(
    w,
    {
      side: "bottom",
      className: "w-[12rem]",
      triggerClassname: "decoration-gray-100",
      usePortal: false,
      content: /* @__PURE__ */ e42__default.createElement("div", { className: "py-0.5 text-gray-100 leading-relaxed" }, "Receive some gas on the destination chain. Requires $", d5 == null ? void 0 : d5.minDestinationGasUSD[(p4 == null ? void 0 : p4.chain_id) ?? 10], " ", "min transaction value.")
    },
    /* @__PURE__ */ e42__default.createElement("p", { className: "text-gray-100 text-sm max-sm:text-xs" }, "Destination Gas")
  ), /* @__PURE__ */ e42__default.createElement(
    l6,
    {
      id: "destination-gas",
      checked: n7 ? false : y,
      onCheckedChange: (r12) => {
        !n7 && A2(r12);
      },
      className: c("mt-[0.1rem]", {
        "cursor-not-allowed": n7
      })
    }
  ))), /* @__PURE__ */ e42__default.createElement("div", { className: "px-5 py-[0.875rem] flex justify-between items-center output-wrapper-section" }, /* @__PURE__ */ e42__default.createElement("div", { className: "space-y-1" }, /* @__PURE__ */ e42__default.createElement("p", { className: "text-xs text-gray-100" }, "You Receive"), /* @__PURE__ */ e42__default.createElement(
    "p",
    {
      className: c(
        "text-[1.375rem] text-gray-500 dark:text-white font-semibold relative",
        "flex items-center space-x-2",
        {
          "text-gray-100 dark:text-gray-100": (s7 == null ? void 0 : s7.toAmountToken) === void 0 || o12
        }
      )
    },
    /* @__PURE__ */ e42__default.createElement("span", { className: "inline-block relative" }, o12 && /* @__PURE__ */ e42__default.createElement("span", { className: "flex items-center space-x-2 absolute h-full pr-20 bg-gray-75 dark:bg-gray-200" }, [0, 1, 2].map((r12) => /* @__PURE__ */ e42__default.createElement(
      "span",
      {
        key: r12,
        className: "loading-dot bg-gray-100 inline-block w-3 h-3"
      }
    ))), /* @__PURE__ */ e42__default.createElement(Fragment, null, "$", (s7 == null ? void 0 : s7.toAmountUSD.toFixed(2)) ?? "0.00")),
    (s7 == null ? void 0 : s7.toChain) == (t31 == null ? void 0 : t31.id.toString()) && y && !o12 && !n7 && !!(s7 != null && s7.destinationGasUSD) && !!a5 && /* @__PURE__ */ e42__default.createElement(
      "span",
      {
        className: "rounded-30 py-1 pr-2.5 pl-1.5 right-0.5 top-[50%] text-xs",
        style: {
          color: t31 == null ? void 0 : t31.text_color,
          backgroundColor: t31 == null ? void 0 : t31.background_color
        }
      },
      "+ $",
      s7.destinationGasUSD,
      " ",
      (w3 = t31 == null ? void 0 : t31.nativeToken) == null ? void 0 : w3.name
    )
  )), /* @__PURE__ */ e42__default.createElement("div", { className: "relative flex items-center output-token-wrapper" }, /* @__PURE__ */ e42__default.createElement(
    u2,
    {
      onClick: () => {
        t31 != null && t31.id && !E2 && c11(true);
      },
      className: c(
        "w-fit pb-[0.05rem] px-[1rem] bg-white dark:bg-gray-500 gap-[0.2rem]",
        {
          "opacity-60 cursor-not-allowed": !(t31 != null && t31.id)
        }
      )
    },
    /* @__PURE__ */ e42__default.createElement(Fragment, null, a5 ? /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center space-x-2 text-gray-500 dark:text-white mr-2 -ml-2" }, /* @__PURE__ */ e42__default.createElement(
      "img",
      {
        alt: a5 == null ? void 0 : a5.name,
        src: a5 == null ? void 0 : a5.logoUrl,
        width: 25,
        height: 25,
        className: "w-[1.875rem] h-[1.875rem] max-sm:w-7 max-sm:h-7 rounded-full"
      }
    ), /* @__PURE__ */ e42__default.createElement("span", null, a5 == null ? void 0 : a5.symbol)) : /* @__PURE__ */ e42__default.createElement("span", { className: "text-gray-100 font-normal mr-2" }, "Select Token")),
    !E2 && /* @__PURE__ */ e42__default.createElement(
      ps,
      {
        svg: "chevron-down",
        className: "w-3 h-3 text-gray-100"
      }
    )
  ), (s7 == null ? void 0 : s7.toAmountToken) && !o12 && /* @__PURE__ */ e42__default.createElement("span", { className: "inline-block absolute right-[calc(100%+0.63rem)]" }, /* @__PURE__ */ e42__default.createElement("p", { className: "text-xs" }, "~", c2(s7.toAmountToken, 4)))))))), /* @__PURE__ */ e42__default.createElement(
    "div",
    {
      className: c(
        "absolute bg-white z-20 output-token-modal rounded-30",
        "dark:bg-gray-300 transition-all duration-200",
        {
          "inset-0": h5,
          "translate-y-20 opacity-0 pointer-events-none": !h5
        }
      )
    },
    /* @__PURE__ */ e42__default.createElement("div", { className: "p-4 border-b border-solid border-gray-90 dark:border-gray-200 space-y-4" }, /* @__PURE__ */ e42__default.createElement("div", { className: "flex items-center justify-between space-x-2" }, /* @__PURE__ */ e42__default.createElement("div", { className: "flex-grow" }, /* @__PURE__ */ e42__default.createElement("div", { className: "border bg-gray-75 border-solid border-gray-90 dark:border-transparent dark:bg-gray-200 max-sm:dark:bg-gray-400 dark:text-white-100 flex items-center px-3.5 py-2.5 space-x-2 rounded-60 min-w-[18rem] max-md:w-full max-sm:px-2.5 max-sm:rounded-[10px]" }, /* @__PURE__ */ e42__default.createElement(
      ps,
      {
        svg: "search",
        className: "text-gray-100 w-6 h-6 max-sm:w-5 max-sm:h-5"
      }
    ), /* @__PURE__ */ e42__default.createElement(
      "input",
      {
        value: "",
        onChange: (r12) => console.log(r12.target.value),
        placeholder: "Search token name or address",
        className: "placeholder:text-gray-100 bg-transparent outline-none h-full w-full text-base"
      }
    ))), /* @__PURE__ */ e42__default.createElement(
      u2,
      {
        variant: "secondary",
        className: "aspect-square h-[2.5rem] outline-none cursor-pointer p-0 shrink-0 max-sm:rounded-[10px]",
        onClick: () => c11(false)
      },
      /* @__PURE__ */ e42__default.createElement(
        ps,
        {
          svg: "cancel",
          className: "w-4 h-4 text-gray-400 dark:text-white"
        }
      )
    )), /* @__PURE__ */ e42__default.createElement(
      "div",
      {
        className: c("flex flex-wrap gap-1.5 rounded-30", {
          hidden: Array.isArray(m5) && (m5 == null ? void 0 : m5.length) > 1
        })
      },
      N.favorites.map((r12, g7) => /* @__PURE__ */ e42__default.createElement(
        u2,
        {
          key: g7,
          variant: "secondary",
          className: c(
            "w-fit border border-solid border-gray-75 dark:border-gray-200 hover:opacity-80 transition-all pl-[0.5rem] pr-[1rem] py-[0.5rem] h-auto",
            {
              "!bg-transparent ": (a5 == null ? void 0 : a5.address) !== r12.address,
              "!bg-gray-75 dark:!bg-gray-200 ring-1 ring-primary": (a5 == null ? void 0 : a5.address) === r12.address
            }
          ),
          onClick: () => {
            f8(r12.address), c11(false);
          }
        },
        /* @__PURE__ */ e42__default.createElement(
          "img",
          {
            src: r12.logoUrl,
            className: "w-6 h-6 shrink-0",
            alt: r12.name,
            width: 25,
            height: 25
          }
        ),
        /* @__PURE__ */ e42__default.createElement("span", { className: "text-base font-medium" }, r12.symbol)
      ))
    )),
    /* @__PURE__ */ e42__default.createElement("div", { className: "overflow-y-auto max-h-[30rem]" }, /* @__PURE__ */ e42__default.createElement("ul", { className: "py-4" }, N.options.map((r12, g7) => /* @__PURE__ */ e42__default.createElement(
      "li",
      {
        key: g7,
        role: "button",
        className: c(
          "py-3 px-4 w-full flex items-center gap-3 cursor-pointer hover:bg-gray-75 dark:hover:bg-gray-500 transition-all",
          {
            "bg-gray-90 dark:bg-gray-400": (a5 == null ? void 0 : a5.address) === r12.address
          }
        ),
        onClick: () => {
          f8(r12.address), c11(false);
        }
      },
      /* @__PURE__ */ e42__default.createElement(
        "img",
        {
          alt: r12.name,
          src: r12.logoUrl,
          width: 25,
          height: 25,
          className: "w-9 h-9 rounded-full"
        }
      ),
      /* @__PURE__ */ e42__default.createElement("div", { className: "flex flex-col items-start origin-left space-y-1" }, /* @__PURE__ */ e42__default.createElement("span", { className: "font-medium" }, r12.name), /* @__PURE__ */ e42__default.createElement("span", { className: "text-xs uppercase text-gray-100 font-medium" }, r12.symbol))
    ))))
  ));
}, "me");
var R4 = /* @__PURE__ */ __name(({
  isModalFootnote: t31,
  className: m5
}) => /* @__PURE__ */ e42__default.createElement(
  "div",
  {
    className: c(
      "footnote text-center pb-4 max-sm:pb-0 flex items-center justify-center gap-0",
      {
        "absolute mx-auto right-0 left-0 ": t31,
        "-bottom-16 max-sm:-bottom-12": !t31
      },
      m5
    )
  },
  /* @__PURE__ */ e42__default.createElement(
    ps,
    {
      svg: "lock-alt",
      className: c("footnote-icon w-6 h-6 mt-[0.1rem]", {
        "text-white": t31,
        "text-gray-500 dark:text-white": !t31
      })
    }
  ),
  /* @__PURE__ */ e42__default.createElement(
    "p",
    {
      className: c("footnote-text text-sm font-light", {
        "text-gray-100": t31,
        "text-gray-300 dark:text-gray-100": !t31
      })
    },
    "powered by",
    " ",
    /* @__PURE__ */ e42__default.createElement(
      "a",
      {
        target: "_blank",
        href: "https://flexy.tech",
        rel: "noreferer noopener",
        className: c(
          "footnote-link underline decoration-solid font-normal",
          {
            "text-gray-90": t31,
            "text-gray-500 dark:text-gray-90": !t31
          }
        )
      },
      "flexy.tech"
    ),
    " "
  )
), "R");
var Transfer = /* @__PURE__ */ __name(({
  walletClientOrSigner,
  limitOutputTokens,
  limitDestination,
  preferredInputToken
}) => {
  const [relayId, setRelayId] = useState();
  useEffect(() => {
    return () => {
      setRelayId(void 0);
    };
  }, []);
  if (relayId) {
    return /* @__PURE__ */ e42__default.createElement(ae, { id: relayId });
  }
  return /* @__PURE__ */ e42__default.createElement("div", { className: "relay" }, /* @__PURE__ */ e42__default.createElement("div", { className: "grid grid-cols-1 gap-3" }, /* @__PURE__ */ e42__default.createElement(ce, null), /* @__PURE__ */ e42__default.createElement(O2, null)), /* @__PURE__ */ e42__default.createElement("div", { className: "pt-8 grid grid-cols-1 gap-3" }, /* @__PURE__ */ e42__default.createElement(
    me,
    {
      limitDestination,
      limitOutputTokens
    }
  ), /* @__PURE__ */ e42__default.createElement(P2, null), /* @__PURE__ */ e42__default.createElement(
    O,
    {
      widgetVersion: "0.0.8",
      walletClientOrSigner,
      preferredInputToken,
      onComplete: (relayId2, callback) => {
        setRelayId(relayId2);
        callback();
      }
    }
  )));
}, "Transfer");
var f7 = /* @__PURE__ */ __name(({
  fontFamily: r12,
  accentColor: s7,
  theme: e44,
  classPrefix: c11
}) => {
  useLayoutEffect(() => {
    const o12 = document.documentElement.style, t31 = c11 ? `${c11}-` : "";
    s7 && o12.setProperty(`--${t31}primary`, s7), r12 && o12.setProperty(`--${t31}font-family`, r12);
    const m5 = "(prefers-color-scheme: dark)", n7 = window.matchMedia(m5);
    function d5() {
      const p4 = e44 === "dark" || !e44 && n7.matches, a5 = document.documentElement.classList;
      p4 ? a5.add("dark") : a5.remove("dark");
      const u6 = getComputedStyle(document.documentElement), y = `--${t31}text-color`, l9 = `--${t31}background-color`;
      if (e44) {
        const g7 = `--${t31}${e44 === "dark" ? "white" : "gray-500"}`, i5 = `--${t31}${e44 === "dark" ? "gray-500" : "gray-75"}`;
        o12.setProperty(y, u6.getPropertyValue(g7)), o12.setProperty(l9, u6.getPropertyValue(i5));
      }
    }
    __name(d5, "d");
    return d5(), n7.addEventListener("change", d5), () => {
      n7.removeEventListener("change", d5);
    };
  }, [s7, c11, r12, e44]);
}, "f");

// src/components/renderer.tsx
var FlexyRenderer = /* @__PURE__ */ __name(({
  children,
  renderMode,
  accentColor,
  fontFamily,
  theme,
  ...props
}) => {
  const [openFlexyModal, setOpenFlexyModal] = useState(false);
  const [loadingIframe, setLoadingIframe] = useState(true);
  f7({
    theme,
    fontFamily,
    accentColor,
    classPrefix: "flexy"
  });
  function renderWrapper(children2) {
    if (renderMode === "iframe" && openFlexyModal) {
      const params = `
        theme=${theme}
        &accentColor=${encodeURIComponent(accentColor)}
        &fontFamily=${fontFamily}`;
      return /* @__PURE__ */ e42__default.createElement(s5, { portalId: "flexy-iframe" }, /* @__PURE__ */ e42__default.createElement("div", { className: "flexy" }, /* @__PURE__ */ e42__default.createElement(
        "div",
        {
          className: c("fixed inset-0 z-[10000]", {
            "bg-gray-75 dark:bg-gray-500": loadingIframe
          })
        },
        loadingIframe && /* @__PURE__ */ e42__default.createElement(c4, null),
        /* @__PURE__ */ e42__default.createElement(
          "iframe",
          {
            width: "100%",
            height: "100%",
            title: "Flexy Refuel",
            loading: "lazy",
            onLoad: () => setLoadingIframe(false),
            src: `https://flexy.tech/iframe?${params.replace(/\s/g, "")}`,
            className: c("relative", {
              invisible: loadingIframe
            })
          }
        ),
        /* @__PURE__ */ e42__default.createElement("div", { className: "absolute right-10 top-10 max-sm:top-1 max-sm:right-1 grid place-items-center gap-y-4 z-50" }, /* @__PURE__ */ e42__default.createElement(
          u2,
          {
            variant: "secondary",
            className: "outline-none cursor-pointer hover:opacity-60 transition-all px-0 aspect-square h-[2.5rem] overflow-hidden max-sm:bg-transparent max-sm:dark:bg-transparent",
            onClick: () => {
              setOpenFlexyModal(false);
              setLoadingIframe(true);
            }
          },
          /* @__PURE__ */ e42__default.createElement("div", { className: "w-full h-full bg-gray-90 dark:bg-gray-200 hover:bg-gray-90 hover:dark:bg-gray-300 grid place-items-center max-sm:bg-transparent max-sm:dark:bg-transparent max-sm:scale-110" }, /* @__PURE__ */ e42__default.createElement(
            ps,
            {
              svg: "cancel",
              className: "w-4 h-4 text-gray-400 dark:text-white"
            }
          ))
        ))
      )));
    }
    if (renderMode === "component") {
      return /* @__PURE__ */ e42__default.createElement("div", { className: "rm-component-container w-[calc(29rem*0.87)] max-sm:w-[calc(100vw*0.87)] h-[44.8rem] relative flex justify-center items-center" }, /* @__PURE__ */ e42__default.createElement("div", { className: "rm-component-inner-container scale-[0.87] w-[29rem] max-sm:w-screen origin-top absolute top-0 mx-auto" }, children2));
    }
    return /* @__PURE__ */ e42__default.createElement(
      B,
      {
        closeOnBlur: false,
        open: openFlexyModal,
        onOpenChange: () => setOpenFlexyModal(false),
        wrapperClassname: "rm-modal-container scale-[0.87] max-sm:h-[108vh] max-sm:grid max-sm:place-items-center",
        className: "rm-modal-inner-container h-fit border-none p-0"
      },
      children2
    );
  }
  __name(renderWrapper, "renderWrapper");
  function renderFlexy() {
    return /* @__PURE__ */ e42__default.createElement(Fragment, null, /* @__PURE__ */ e42__default.createElement(
      "div",
      {
        className: c(
          "tabs w-full max-sm:rounded-22 sm:overflow-hidden dark:border-none rounded-22 overflow-hidden h-fit",
          {
            "border border-solid border-gray-90": renderMode === "component"
          }
        )
      },
      /* @__PURE__ */ e42__default.createElement("div", { className: "bg-white dark:bg-gray-300 p-6 tabs-content-wrapper" }, /* @__PURE__ */ e42__default.createElement(Transfer, { ...props }))
    ), /* @__PURE__ */ e42__default.createElement(
      R4,
      {
        className: "pt-6",
        isModalFootnote: renderMode !== "component"
      }
    ));
  }
  __name(renderFlexy, "renderFlexy");
  return /* @__PURE__ */ e42__default.createElement("div", { className: "flexy flexy-renderer" }, children({
    openFlexyModal: () => setOpenFlexyModal(true)
  }), renderWrapper(renderFlexy()));
}, "FlexyRenderer");

// src/index.tsx
var Flexy = /* @__PURE__ */ __name(({ renderMode = "icon", ...props }) => {
  return /* @__PURE__ */ e42__default.createElement(FlexyRenderer, { renderMode, ...props }, ({ openFlexyModal }) => {
    const renderButton = /* @__PURE__ */ __name((children) => {
      switch (renderMode) {
        case "floating-icon":
          return /* @__PURE__ */ e42__default.createElement(s5, { portalId: "flexy" }, children);
        case "icon":
          return children;
        case "iframe":
          return children;
        default:
          return null;
      }
    }, "renderButton");
    return renderButton(
      /* @__PURE__ */ e42__default.createElement(
        u2,
        {
          onClick: openFlexyModal,
          className: c("rounded-full px-0 py-0 aspect-square", {
            "fixed bottom-8 right-10": renderMode === "floating-icon"
          })
        },
        /* @__PURE__ */ e42__default.createElement(
          ps,
          {
            className: "w-5 h-5 relative -bottom-[0.05rem] -right-[0.04rem]",
            svg: "bolt"
          }
        )
      )
    );
  });
}, "Flexy");
Flexy.CustomRender = FlexyRenderer;

export { Flexy };
